(function(e, a) { for(var i in a) e[i] = a[i]; }(exports, /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "./src/index.ts");
/******/ })
/************************************************************************/
/******/ ({

/***/ "./node_modules/rtlcss/lib/config.js":
/*!*******************************************!*\
  !*** ./node_modules/rtlcss/lib/config.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var options
var config = {}
var corePlugin = __webpack_require__(/*! ./plugin.js */ "./node_modules/rtlcss/lib/plugin.js")

function optionOrDefault (option, def) {
  return option in options ? options[option] : def
}

function addKey (key, def) {
  config[key] = optionOrDefault(key, def)
}

function main (opts, plugins, hooks) {
  options = opts || {}
  hooks = hooks || {}
  addKey('autoRename', false)
  addKey('autoRenameStrict', false)
  addKey('blacklist', {})
  addKey('clean', true)
  addKey('greedy', false)
  addKey('processUrls', false)
  addKey('stringMap', [])
  addKey('useCalc', false)

  // default strings map
  if (Array.isArray(config.stringMap)) {
    var hasLeftRight, hasLtrRtl
    for (var x = 0; x < config.stringMap.length; x++) {
      var map = config.stringMap[x]
      if (hasLeftRight && hasLtrRtl) {
        break
      } else if (map.name === 'left-right') {
        hasLeftRight = true
      } else if (map.name === 'ltr-rtl') {
        hasLtrRtl = true
      }
    }
    if (!hasLeftRight) {
      config.stringMap.push({
        'name': 'left-right',
        'priority': 100,
        'exclusive': false,
        'search': ['left', 'Left', 'LEFT'],
        'replace': ['right', 'Right', 'RIGHT'],
        'options': { 'scope': '*', 'ignoreCase': false }
      })
    }
    if (!hasLtrRtl) {
      config.stringMap.push({
        'name': 'ltr-rtl',
        'priority': 100,
        'exclusive': false,
        'search': ['ltr', 'Ltr', 'LTR'],
        'replace': ['rtl', 'Rtl', 'RTL'],
        'options': { 'scope': '*', 'ignoreCase': false }
      })
    }
    config.stringMap.sort(function (a, b) { return a.priority - b.priority })
  }

  // plugins
  config.plugins = []

  if (Array.isArray(plugins)) {
    if (!plugins.some(function (plugin) { return plugin.name === 'rtlcss' })) {
      config.plugins.push(corePlugin)
    }
    config.plugins = config.plugins.concat(plugins)
  } else if (!plugins || plugins.name !== 'rtlcss') {
    config.plugins.push(corePlugin)
  }
  config.plugins.sort(function (a, b) { return a.priority - b.priority })

  // hooks
  config.hooks = { pre: function () {}, post: function () {} }
  if (typeof hooks.pre === 'function') {
    config.hooks.pre = hooks.pre
  }
  if (typeof hooks.post === 'function') {
    config.hooks.post = hooks.post
  }

  return config
}
module.exports.configure = main


/***/ }),

/***/ "./node_modules/rtlcss/lib/directive-parser.js":
/*!*****************************************************!*\
  !*** ./node_modules/rtlcss/lib/directive-parser.js ***!
  \*****************************************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = function (comment) {
  var pos = 0
  var value = comment.text
  var match = value.match(/^\s*!?\s*rtl:/)
  var meta

  if (match) {
    meta = {
      'source': comment,
      'name': '',
      'param': '',
      'begin': true,
      'end': true,
      'blacklist': false,
      'preserve': false
    }
    value = value.slice(match[0].length)
    pos = value.indexOf(':')

    if (pos > -1) {
      meta.name = value.slice(0, pos)
      // begin/end are always true, unless one of them actually exists.
      meta.begin = meta.name !== 'end'
      meta.end = meta.name !== 'begin'
      if (meta.name === 'begin' || meta.name === 'end') {
        value = value.slice(meta.name.length + 1)
        pos = value.indexOf(':')
        if (pos > -1) {
          meta.name = value.slice(0, pos)
          value = value.slice(pos)
          meta.param = value.slice(1)
        } else {
          meta.name = value
        }
      } else {
        meta.param = value.slice(pos + 1)
      }
    } else {
      meta.name = value
    }
  }
  return meta
}


/***/ }),

/***/ "./node_modules/rtlcss/lib/plugin.js":
/*!*******************************************!*\
  !*** ./node_modules/rtlcss/lib/plugin.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var config = __webpack_require__(/*! ./config.js */ "./node_modules/rtlcss/lib/config.js")
var util = __webpack_require__(/*! ./util.js */ "./node_modules/rtlcss/lib/util.js")
module.exports = {
  'name': 'rtlcss',
  'priority': 100,
  'directives': {
    'control': {
      'ignore': {
        'expect': { 'atrule': true, 'comment': true, 'decl': true, 'rule': true },
        'endNode': null,
        'begin': function (node, metadata, context) {
          // find the ending node in case of self closing directive
          if (!this.endNode && metadata.begin && metadata.end) {
            var n = node
            while (n && n.nodes) {
              n = n.nodes[n.nodes.length - 1]
            }
            this.endNode = n
          }
          var prevent = true
          if (node.type === 'comment' && node.text.match(/^\s*!?\s*rtl:end:ignore/)) {
            prevent = false
          }
          return prevent
        },
        'end': function (node, metadata, context) {
          // end if:
          //  1. block directive and the node is comment
          //  2. self closing directive and node is endNode
          if (metadata.begin !== metadata.end && node.type === 'comment' || metadata.begin && metadata.end && node === this.endNode) {
            // clear ending node
            this.endNode = null
            return true
          }
          return false
        }
      },
      'rename': {
        'expect': {'rule': true},
        'begin': function (node, metadata, context) {
          node.selector = context.util.applyStringMap(node.selector, false)
          return false
        },
        'end': function (node, context) {
          return true
        }
      },
      'raw': {
        'expect': {'self': true},
        'begin': function (node, metadata, context) {
          var nodes = context.postcss.parse(metadata.param)
          node.parent.insertBefore(node, nodes)
          return true
        },
        'end': function (node, context) {
          return true
        }
      },
      'remove': {
        'expect': {'atrule': true, 'rule': true, 'decl': true},
        'begin': function (node, metadata, context) {
          var prevent = false
          switch (node.type) {
            case 'atrule':
            case 'rule':
            case 'decl':
              prevent = true
              node.remove()
          }
          return prevent
        },
        'end': function (node, metadata, context) {
          return true
        }
      },
      'options': {
        'expect': {'self': true},
        'stack': [],
        'begin': function (node, metadata, context) {
          this.stack.push(util.extend({}, context.config))
          var options
          try {
            options = JSON.parse(metadata.param)
          } catch (e) {
            throw node.error('Invlaid options object', { 'details': e })
          }
          context.config = config.configure(options, context.config.plugins)
          context.util = util.configure(context.config)
          return true
        },
        'end': function (node, metadata, context) {
          var config = this.stack.pop()
          if (config && !metadata.begin) {
            context.config = config
            context.util = util.configure(context.config)
          }
          return true
        }
      },
      'config': {
        'expect': {'self': true},
        'expr': {
          'fn': /function([^\(]*)\(([^\(\)]*?)\)[^\{]*\{([^]*)\}/ig,
          'rx': /\/([^\/]*)\/(.*)/ig
        },
        'stack': [],
        'begin': function (node, metadata, context) {
          this.stack.push(util.extend({}, context.config))
          var configuration
          try {
            configuration = eval('(' + metadata.param + ')') // eslint-disable-line no-eval
          } catch (e) {
            throw node.error('Invlaid config object', { 'details': e })
          }
          context.config = config.configure(configuration.options, configuration.plugins)
          context.util = util.configure(context.config)
          return true
        },
        'end': function (node, metadata, context) {
          var config = this.stack.pop()
          if (config && !metadata.begin) {
            context.config = config
            context.util = util.configure(context.config)
          }
          return true
        }
      }
    },
    'value': [
      {
        'name': 'ignore',
        'action': function (decl, expr, context) {
          return true
        }
      },
      {
        'name': 'prepend',
        'action': function (decl, expr, context) {
          var prefix = ''
          decl.raws.value.raw.replace(expr, function (m, v) {
            prefix += v
          })
          decl.value = decl.raws.value.raw = prefix + decl.raws.value.raw
          return true
        }
      },
      {
        'name': 'append',
        'action': function (decl, expr, context) {
          decl.value = decl.raws.value.raw = decl.raws.value.raw.replace(expr, function (match, value) {
            return match + value
          })
          return true
        }
      },
      {
        'name': 'insert',
        'action': function (decl, expr, context) {
          decl.value = decl.raws.value.raw = decl.raws.value.raw.replace(expr, function (match, value) {
            return value + match
          })
          return true
        }
      },
      {
        'name': '',
        'action': function (decl, expr, context) {
          decl.raws.value.raw.replace(expr, function (match, value) {
            decl.value = decl.raws.value.raw = value + match
          })
          return true
        }
      }
    ]
  },
  'processors': [
    {
      'name': 'variable',
      'expr': /^--/im,
      'action': function (prop, value) {
        return { 'prop': prop, 'value': value }
      }
    },
    {
      'name': 'direction',
      'expr': /direction/im,
      'action': function (prop, value, context) {
        return { 'prop': prop, 'value': context.util.swapLtrRtl(value) }
      }
    },
    {
      'name': 'left',
      'expr': /left/im,
      'action': function (prop, value, context) {
        return { 'prop': prop.replace(this.expr, function () { return 'right' }), 'value': value }
      }
    },
    {
      'name': 'right',
      'expr': /right/im,
      'action': function (prop, value, context) {
        return { 'prop': prop.replace(this.expr, function () { return 'left' }), 'value': value }
      }
    },
    {
      'name': 'four-value syntax',
      'expr': /^(margin|padding|border-(color|style|width))$/ig,
      'cache': null,
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'match': /[^\s\uFFFD]+/g
          }
        }
        var state = context.util.guardFunctions(value)
        var result = state.value.match(this.cache.match)
        if (result && result.length === 4 && (state.store.length > 0 || result[1] !== result[3])) {
          var i = 0
          state.value = state.value.replace(this.cache.match, function () {
            return result[(4 - i++) % 4]
          })
        }
        return { 'prop': prop, 'value': context.util.unguardFunctions(state) }
      }
    },
    {
      'name': 'border radius',
      'expr': /border-radius/ig,
      'cache': null,
      'flip': function (value) {
        var parts = value.match(this.cache.match)
        var i
        if (parts) {
          switch (parts.length) {
            case 2:
              i = 1
              if (parts[0] !== parts[1]) {
                value = value.replace(this.cache.match, function () {
                  return parts[i--]
                })
              }
              break
            case 3:
              // preserve leading whitespace.
              value = value.replace(this.cache.white, function (m) {
                return m + parts[1] + ' '
              })
              break
            case 4:
              i = 0
              if (parts[0] !== parts[1] || parts[2] !== parts[3]) {
                value = value.replace(this.cache.match, function () {
                  return parts[(5 - i++) % 4]
                })
              }
              break
          }
        }
        return value
      },
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'match': /[^\s\uFFFD]+/g,
            'slash': /[^\/]+/g,
            'white': /(^\s*)/
          }
        }
        var state = context.util.guardFunctions(value)
        state.value = state.value.replace(this.cache.slash, function (m) {
          return this.flip(m)
        }.bind(this))
        return { 'prop': prop, 'value': context.util.unguardFunctions(state) }
      }
    },
    {
      'name': 'shadow',
      'expr': /shadow/ig,
      'cache': null,
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'replace': /[^,]+/g
          }
        }
        var colorSafe = context.util.guardHexColors(value)
        var funcSafe = context.util.guardFunctions(colorSafe.value)
        funcSafe.value = funcSafe.value.replace(this.cache.replace, function (m) { return context.util.negate(m) })
        colorSafe.value = context.util.unguardFunctions(funcSafe)
        return { 'prop': prop, 'value': context.util.unguardHexColors(colorSafe) }
      }
    },
    {
      'name': 'transform and perspective origin',
      'expr': /(?:transform|perspective)-origin/ig,
      'cache': null,
      'flip': function (value, context) {
        if (value === '0') {
          value = '100%'
        } else if (value.match(this.cache.percent)) {
          value = context.util.complement(value)
        } else if (value.match(this.cache.length)) {
          value = context.util.flipLength(value)
        }
        return value
      },
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'match': context.util.regex(['calc', 'percent', 'length'], 'g'),
            'percent': context.util.regex(['calc', 'percent'], 'i'),
            'length': context.util.regex(['length'], 'gi'),
            'xKeyword': /(left|right)/i
          }
        }
        if (value.match(this.cache.xKeyword)) {
          value = context.util.swapLeftRight(value)
        } else {
          var state = context.util.guardFunctions(value)
          var parts = state.value.match(this.cache.match)
          if (parts && parts.length > 0) {
            parts[0] = this.flip(parts[0], context)
            state.value = state.value.replace(this.cache.match, function () { return parts.shift() })
            value = context.util.unguardFunctions(state)
          }
        }
        return { 'prop': prop, 'value': value }
      }
    },
    {
      'name': 'transform',
      'expr': /^(?!text\-).*?transform$/ig,
      'cache': null,
      'flip': function (value, process, context) {
        var i = 0
        return value.replace(this.cache.unit, function (num) {
          return process(++i, num)
        })
      },
      'flipMatrix': function (value, context) {
        return this.flip(value, function (i, num) {
          if (i === 2 || i === 3 || i === 5) {
            return context.util.negate(num)
          }
          return num
        }, context)
      },
      'flipMatrix3D': function (value, context) {
        return this.flip(value, function (i, num) {
          if (i === 2 || i === 4 || i === 5 || i === 13) {
            return context.util.negate(num)
          }
          return num
        }, context)
      },
      'flipRotate3D': function (value, context) {
        return this.flip(value, function (i, num) {
          if (i === 1 || i === 4) {
            return context.util.negate(num)
          }
          return num
        }, context)
      },
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'negatable': /((translate)(x|3d)?|rotate(z|y)?)$/ig,
            'unit': context.util.regex(['calc', 'number'], 'g'),
            'matrix': /matrix$/i,
            'matrix3D': /matrix3d$/i,
            'skewXY': /skew(x|y)?$/i,
            'rotate3D': /rotate3d$/i
          }
        }
        var state = context.util.guardFunctions(value)
        return {
          'prop': prop,
          'value': context.util.unguardFunctions(state, function (v, n) {
            if (n.length) {
              if (n.match(this.cache.matrix3D)) {
                v = this.flipMatrix3D(v, context)
              } else if (n.match(this.cache.matrix)) {
                v = this.flipMatrix(v, context)
              } else if (n.match(this.cache.rotate3D)) {
                v = this.flipRotate3D(v, context)
              } else if (n.match(this.cache.skewXY)) {
                v = context.util.negateAll(v)
              } else if (n.match(this.cache.negatable)) {
                v = context.util.negate(v)
              }
            }
            return v
          }.bind(this))
        }
      }
    },
    {
      'name': 'transition',
      'expr': /transition(-property)?$/i,
      'action': function (prop, value, context) {
        return { 'prop': prop, 'value': context.util.swapLeftRight(value) }
      }
    },
    {
      'name': 'background',
      'expr': /background(-position(-x)?|-image)?$/i,
      'cache': null,
      'flip': function (value, context) {
        var state = util.saveTokens(value, true)
        var parts = state.value.match(this.cache.match)

        if (parts && parts.length > 0) {
          var keywords = (state.value.match(this.cache.position) || '').length
          if (/* edge offsets */ parts.length >= 3 || /* keywords only */ keywords === 2) {
            state.value = util.swapLeftRight(state.value)
          } else {
            parts[0] = parts[0] === '0'
              ? '100%'
              : (parts[0].match(this.cache.percent)
                ? context.util.complement(parts[0])
                : (parts[0].match(this.cache.length)
                  ? context.util.flipLength(parts[0])
                  : context.util.swapLeftRight(parts[0])))
            state.value = state.value.replace(this.cache.match, function () { return parts.shift() })
          }
        }
        return util.restoreTokens(state)
      },
      'update': function (context, value, name) {
        if (name.match(this.cache.gradient)) {
          value = context.util.swapLeftRight(value)
          if (value.match(this.cache.angle)) {
            value = context.util.negate(value)
          }
        } else if (context.config.processUrls === true || context.config.processUrls.decl === true && name.match(this.cache.url)) {
          value = context.util.applyStringMap(value, true)
        }
        return value
      },
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'match': context.util.regex(['position', 'percent', 'length', 'calc'], 'ig'),
            'percent': context.util.regex(['calc', 'percent'], 'i'),
            'position': context.util.regex(['position'], 'g'),
            'length': context.util.regex(['length'], 'gi'),
            'gradient': /gradient$/i,
            'angle': /\d+(deg|g?rad|turn)/i,
            'url': /^url/i
          }
        }
        var colorSafe = context.util.guardHexColors(value)
        var funcSafe = context.util.guardFunctions(colorSafe.value)
        var parts = funcSafe.value.split(',')
        var lprop = prop.toLowerCase()
        if (lprop !== 'background-image') {
          for (var x = 0; x < parts.length; x++) {
            parts[x] = this.flip(parts[x], context)
          }
        }
        funcSafe.value = parts.join(',')
        colorSafe.value = context.util.unguardFunctions(funcSafe, this.update.bind(this, context))
        return {
          'prop': prop,
          'value': context.util.unguardHexColors(colorSafe)
        }
      }
    },
    {
      'name': 'keyword',
      'expr': /float|clear|text-align/i,
      'action': function (prop, value, context) {
        return { 'prop': prop, 'value': context.util.swapLeftRight(value) }
      }
    },
    {
      'name': 'cursor',
      'expr': /cursor/i,
      'cache': null,
      'update': function (context, value, name) {
        if (context.config.processUrls === true || context.config.processUrls.decl === true && name.match(this.cache.url)) {
          value = context.util.applyStringMap(value, true)
        }
        return value
      },
      'flip': function (value) {
        return value.replace(this.cache.replace, function (s, m) {
          return s.replace(m, m.replace(this.cache.e, '*').replace(this.cache.w, 'e').replace(this.cache.star, 'w'))
        }.bind(this))
      },
      'action': function (prop, value, context) {
        if (this.cache === null) {
          this.cache = {
            'replace': /\b(ne|nw|se|sw|nesw|nwse)-resize/ig,
            'url': /^url/i,
            'e': /e/i,
            'w': /w/i,
            'star': /\*/i
          }
        }
        var state = context.util.guardFunctions(value)
        var parts = state.value.split(',')
        for (var x = 0; x < parts.length; x++) {
          parts[x] = this.flip(parts[x])
        }
        state.value = parts.join(',')
        return {
          'prop': prop,
          'value': context.util.unguardFunctions(state, this.update.bind(this, context))
        }
      }
    }
  ]
}


/***/ }),

/***/ "./node_modules/rtlcss/lib/rtlcss.js":
/*!*******************************************!*\
  !*** ./node_modules/rtlcss/lib/rtlcss.js ***!
  \*******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
 * RTLCSS https://github.com/MohammadYounes/rtlcss
 * Framework for transforming Cascading Style Sheets (CSS) from Left-To-Right (LTR) to Right-To-Left (RTL).
 * Copyright 2017 Mohammad Younes.
 * Licensed under MIT <http://opensource.org/licenses/mit-license.php>
 * */

var postcss = __webpack_require__(/*! postcss */ "postcss")
var state = __webpack_require__(/*! ./state.js */ "./node_modules/rtlcss/lib/state.js")
var config = __webpack_require__(/*! ./config.js */ "./node_modules/rtlcss/lib/config.js")
var util = __webpack_require__(/*! ./util.js */ "./node_modules/rtlcss/lib/util.js")

module.exports = postcss.plugin('rtlcss', function (options, plugins, hooks) {
  var configuration = config.configure(options, plugins, hooks)
  var context = {
    // provides access to postcss
    'postcss': postcss,
    // provides access to the current configuration
    'config': configuration,
    // provides access to utilities object
    'util': util.configure(configuration)
  }
  return function (css, result) {
    var flipped = 0
    var toBeRenamed = {}
    context.config.hooks.pre(css, postcss)
    css.walk(function (node) {
      var prevent = false
      state.walk(function (current) {
        // check if current directive is expecting this node
        if (!current.metadata.blacklist && current.directive.expect[node.type]) {
          // perform action and prevent further processing if result equals true
          if (current.directive.begin(node, current.metadata, context)) {
            prevent = true
          }
          // if should end? end it.
          if (current.metadata.end && current.directive.end(node, current.metadata, context)) {
            state.pop(current)
          }
        }
      })

      if (prevent === false) {
        switch (node.type) {
          case 'atrule':
            // @rules requires url flipping only
            if (context.config.processUrls === true || context.config.processUrls.atrule === true) {
              var params = context.util.applyStringMap(node.params, true)
              node.params = params
            }
            break
          case 'comment':
            state.parse(node, result, function (current) {
              var push = true
              if (current.directive === null) {
                current.preserve = !context.config.clean
                context.util.each(context.config.plugins, function (plugin) {
                  var blacklist = context.config.blacklist[plugin.name]
                  if (blacklist && blacklist[current.metadata.name] === true) {
                    current.metadata.blacklist = true
                    if (current.metadata.end) {
                      push = false
                    }
                    if (current.metadata.begin) {
                      result.warn('directive "' + plugin.name + '.' + current.metadata.name + '" is blacklisted.', {node: current.source})
                    }
                    // break each
                    return false
                  }
                  current.directive = plugin.directives.control[current.metadata.name]
                  if (current.directive) {
                    // break each
                    return false
                  }
                })
              }
              if (current.directive) {
                if (!current.metadata.begin && current.metadata.end) {
                  if (current.directive.end(node, current.metadata, context)) {
                    state.pop(current)
                  }
                  push = false
                } else if (current.directive.expect.self && current.directive.begin(node, current.metadata, context)) {
                  if (current.metadata.end && current.directive.end(node, current.metadata, context)) {
                    push = false
                  }
                }
              } else if (!current.metadata.blacklist) {
                push = false
                result.warn('unsupported directive "' + current.metadata.name + '".', {node: current.source})
              }
              return push
            })
            break
          case 'decl':
            // if broken by a matching value directive .. break
            if (!context.util.each(context.config.plugins,
                function (plugin) {
                  return context.util.each(plugin.directives.value, function (directive) {
                    if (node.raws.value && node.raws.value.raw) {
                      var expr = context.util.regexDirective(directive.name)
                      if (expr.test(node.raws.value.raw)) {
                        expr.lastIndex = 0
                        if (directive.action(node, expr, context)) {
                          if (context.config.clean) {
                            node.value = node.raws.value.raw = context.util.trimDirective(node.raws.value.raw)
                          }
                          flipped++
                          // break
                          return false
                        }
                      }
                    }
                  })
                })) break
            // loop over all plugins/property processors
            context.util.each(context.config.plugins, function (plugin) {
              return context.util.each(plugin.processors, function (processor) {
                if (node.prop.match(processor.expr)) {
                  var raw = node.raws.value && node.raws.value.raw ? node.raws.value.raw : node.value
                  var state = context.util.saveComments(raw)
                  var pair = processor.action(node.prop, state.value, context)
                  state.value = pair.value
                  pair.value = context.util.restoreComments(state)
                  if (pair.prop !== node.prop || pair.value !== raw) {
                    flipped++
                    node.prop = pair.prop
                    node.value = pair.value
                  }
                  // match found, break
                  return false
                }
              })
            })
            // if last decl, apply auto rename
            // decl. may be found inside @rules
            if (context.config.autoRename && !flipped && node.parent.type === 'rule' && context.util.isLastOfType(node)) {
              var renamed = context.util.applyStringMap(node.parent.selector)
              if (context.config.autoRenameStrict === true) {
                var pair = toBeRenamed[renamed]
                if (pair) {
                  pair.selector = node.parent.selector
                  node.parent.selector = renamed
                } else {
                  toBeRenamed[node.parent.selector] = node.parent
                }
              } else {
                node.parent.selector = renamed
              }
            }
            break
          case 'rule':
            // new rule, reset flipped decl count to zero
            flipped = 0
            break
        }
      }
    })
    state.walk(function (item) {
      result.warn('unclosed directive "' + item.metadata.name + '".', {node: item.source})
    })
    Object.keys(toBeRenamed).forEach(function (key) {
      result.warn('renaming skipped due to lack of a matching pair.', {node: toBeRenamed[key]})
    })
    context.config.hooks.post(css, postcss)
  }
})

/**
 * Creates a new RTLCSS instance, process the input and return its result.
 * @param {String}  css  A string containing input CSS.
 * @param {Object}  options  An object containing RTLCSS settings.
 * @param {Object|Array}  plugins An array containing a list of RTLCSS plugins or a single RTLCSS plugin.
 * @param {Object}  hooks An object containing pre/post hooks.
 * @returns	{String}	A string contining the RTLed css.
 */
module.exports.process = function (css, options, plugins, hooks) {
  return postcss([this(options, plugins, hooks)]).process(css).css
}

/**
 * Creates a new instance of RTLCSS using the passed configuration object
 * @param {Object}  config  An object containing RTLCSS options, plugins and hooks.
 * @returns {Object}  A new RTLCSS instance.
 */
module.exports.configure = function (config) {
  config = config || {}
  return postcss([this(config.options, config.plugins, config.hooks)])
}


/***/ }),

/***/ "./node_modules/rtlcss/lib/state.js":
/*!******************************************!*\
  !*** ./node_modules/rtlcss/lib/state.js ***!
  \******************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var directiveParser = __webpack_require__(/*! ./directive-parser.js */ "./node_modules/rtlcss/lib/directive-parser.js")
module.exports = {
  stack: [],
  pop: function (current) {
    var index = this.stack.indexOf(current)
    if (index !== -1) {
      this.stack.splice(index, 1)
    }
    if (!current.preserve) {
      current.source.remove()
    }
  },
  parse: function (node, lazyResult, callback) {
    var current
    var metadata = directiveParser(node)
    if (metadata) {
      if (!metadata.begin && metadata.end) {
        this.walk(function (item) {
          if (metadata.name === item.metadata.name) {
            this.pop(item)
            current = {'metadata': metadata, 'directive': item.directive, 'source': node, 'preserve': item.preserve}
            return false
          }
        }.bind(this))
      } else {
        current = {'metadata': metadata, 'directive': null, 'source': node, 'preserve': null}
      }

      if (current === undefined) {
        lazyResult.warn('found end "' + metadata.name + '" without a matching begin.', {node: node})
      } else if (callback(current)) {
        this.stack.push(current)
      } else if (!current.preserve) {
        current.source.remove()
      }
    }
  },
  walk: function (callback) {
    var len = this.stack.length
    while (--len > -1) {
      if (!callback(this.stack[len])) {
        break
      }
    }
  }
}


/***/ }),

/***/ "./node_modules/rtlcss/lib/util.js":
/*!*****************************************!*\
  !*** ./node_modules/rtlcss/lib/util.js ***!
  \*****************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var config
var CHAR_COMMENT_REPLACEMENT = '\uFFFD' // �
var CHAR_TOKEN_REPLACEMENT = '\u00A4'// ¤
var CHAR_TOKEN_START = '\u00AB' // «
var CHAR_TOKEN_END = '\u00BB' // »

var REGEX_COMMENT_REPLACEMENT = new RegExp(CHAR_COMMENT_REPLACEMENT, 'ig')
var REGEX_TOKEN_REPLACEMENT = new RegExp(CHAR_TOKEN_REPLACEMENT, 'ig')

var PATTERN_NUMBER = '\\-?(\\d*?\\.\\d+|\\d+)'
var PATTERN_NUMBER_WITH_CALC = '(calc' + CHAR_TOKEN_REPLACEMENT + ')|(' + PATTERN_NUMBER + ')(?!d\\()'
var PATTERN_TOKEN = CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END // «offset:index»
var PATTERN_TOKEN_WITH_NAME = '\\w*?' + CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END // «offset:index»

var REGEX_COMMENT = /\/\*[^]*?\*\//igm // none-greedy
var REGEX_DIRECTIVE = /\/\*\s*(?:!)?\s*rtl:[^]*?\*\//img
var REGEX_ESCAPE = /[.*+?^${}()|[\]\\]/g
var REGEX_FUNCTION = /\([^\(\)]+\)/i
var REGEX_HEX_COLOR = /#[a-f0-9]{3,6}/ig
var REGEX_CALC = /calc/
var REGEX_TOKENS = new RegExp(PATTERN_TOKEN, 'ig')
var REGEX_TOKENS_WITH_NAME = new RegExp(PATTERN_TOKEN_WITH_NAME, 'ig')

var REGEX_COMPLEMENT = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i')
var REGEX_NEGATE_ALL = new RegExp(PATTERN_NUMBER_WITH_CALC, 'ig')
var REGEX_NEGATE_ONE = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i')

var DEFAULT_STRING_MAP_OPTIONS = { scope: '*', ignoreCase: true }
var TOKEN_ID = 0

function compare (what, to, ignoreCase) {
  if (ignoreCase) {
    return what.toLowerCase() === to.toLowerCase()
  }
  return what === to
}

function escapeRegExp (string) {
  return string.replace(REGEX_ESCAPE, '\\$&')
}

module.exports = {
  extend: function (dest, src) {
    if (typeof dest === 'undefined' || typeof dest !== 'object') {
      dest = {}
    }
    for (var prop in src) {
      if (!dest.hasOwnProperty(prop)) {
        dest[prop] = src[prop]
      }
    }
    return dest
  },
  swap: function (value, a, b, options) {
    var expr = escapeRegExp(a) + '|' + escapeRegExp(b)
    options = options || DEFAULT_STRING_MAP_OPTIONS
    var greedy = options.hasOwnProperty('greedy') ? options.greedy : config.greedy
    if (!greedy) {
      expr = '\\b(' + expr + ')\\b'
    }
    var flags = options.ignoreCase ? 'img' : 'mg'
    return value.replace(new RegExp(expr, flags), function (m) { return compare(m, a, options.ignoreCase) ? b : a })
  },
  swapLeftRight: function (value) {
    return this.swap(value, 'left', 'right')
  },
  swapLtrRtl: function (value) {
    return this.swap(value, 'ltr', 'rtl')
  },
  applyStringMap: function (value, isUrl) {
    var result = value
    for (var x = 0; x < config.stringMap.length; x++) {
      var map = config.stringMap[x]
      var options = this.extend(map.options, DEFAULT_STRING_MAP_OPTIONS)
      if (options.scope === '*' || (isUrl && options.scope === 'url') || (!isUrl && options.scope === 'selector')) {
        if (Array.isArray(map.search) && Array.isArray(map.replace)) {
          for (var mapIndex = 0; mapIndex < map.search.length; mapIndex++) {
            result = this.swap(result, map.search[mapIndex], map.replace[mapIndex % map.search.length], options)
          }
        } else {
          result = this.swap(result, map.search, map.replace, options)
        }
        if (map.exclusive === true) {
          break
        }
      }
    }
    return result
  },
  negate: function (value) {
    var state = this.saveTokens(value)
    state.value = state.value.replace(REGEX_NEGATE_ONE, function (num) {
      return REGEX_TOKEN_REPLACEMENT.test(num) ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) { return '(-1*' + m + ')' }) : parseFloat(num, 10) * -1
    })
    return this.restoreTokens(state)
  },
  negateAll: function (value) {
    var state = this.saveTokens(value)
    state.value = state.value.replace(REGEX_NEGATE_ALL, function (num) {
      return REGEX_TOKEN_REPLACEMENT.test(num) ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) { return '(-1*' + m + ')' }) : parseFloat(num, 10) * -1
    })
    return this.restoreTokens(state)
  },
  complement: function (value) {
    var state = this.saveTokens(value)
    state.value = state.value.replace(REGEX_COMPLEMENT, function (num) {
      return REGEX_TOKEN_REPLACEMENT.test(num) ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) { return '(100% - ' + m + ')' }) : 100 - parseFloat(num, 10)
    })
    return this.restoreTokens(state)
  },
  flipLength: function (value) {
    return config.useCalc ? 'calc(100% - ' + value + ')' : value
  },
  save: function (what, who, replacement, restorer, exclude) {
    var state = {
      value: who,
      store: [],
      replacement: replacement,
      restorer: restorer
    }
    state.value = state.value.replace(what, function (c) {
      if (exclude && c.match(exclude)) {
        return c
      } else {
        state.store.push(c); return state.replacement
      }
    })
    return state
  },
  restore: function (state) {
    var index = 0
    var result = state.value.replace(state.restorer, function () {
      return state.store[index++]
    })
    state.store.length = 0
    return result
  },
  saveComments: function (value) {
    return this.save(REGEX_COMMENT, value, CHAR_COMMENT_REPLACEMENT, REGEX_COMMENT_REPLACEMENT)
  },
  restoreComments: function (state) {
    return this.restore(state)
  },
  saveTokens: function (value, excludeCalc) {
    return excludeCalc === true
      ? this.save(REGEX_TOKENS_WITH_NAME, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT, REGEX_CALC)
      : this.save(REGEX_TOKENS, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT)
  },
  restoreTokens: function (state) {
    return this.restore(state)
  },
  guard: function (what, who, indexed) {
    var state = {
      value: who,
      store: [],
      offset: TOKEN_ID++,
      token: CHAR_TOKEN_START + TOKEN_ID,
      indexed: indexed === true
    }
    if (state.indexed === true) {
      while (what.test(state.value)) {
        state.value = state.value.replace(what, function (m) { state.store.push(m); return state.token + ':' + state.store.length + CHAR_TOKEN_END })
      }
    } else {
      state.value = state.value.replace(what, function (m) { state.store.push(m); return state.token + CHAR_TOKEN_END })
    }
    return state
  },
  unguard: function (state, callback) {
    if (state.indexed === true) {
      var detokenizer = new RegExp('(\\w*?)' + state.token + ':(\\d+)' + CHAR_TOKEN_END, 'i')
      while (detokenizer.test(state.value)) {
        state.value = state.value.replace(detokenizer, function (match, name, index) {
          var value = state.store[index - 1]
          if (typeof callback === 'function') {
            return name + callback(value, name)
          }
          return name + value
        })
      }
      return state.value
    } else {
      return state.value.replace(new RegExp('(\\w*?)' + state.token + CHAR_TOKEN_END, 'i'), function (match, name) {
        var value = state.store.shift()
        if (typeof callback === 'function') {
          return name + callback(value, name)
        }
        return name + value
      })
    }
  },
  guardHexColors: function (value) {
    return this.guard(REGEX_HEX_COLOR, value, true)
  },
  unguardHexColors: function (state, callback) {
    return this.unguard(state, callback)
  },
  guardFunctions: function (value) {
    return this.guard(REGEX_FUNCTION, value, true)
  },
  unguardFunctions: function (state, callback) {
    return this.unguard(state, callback)
  },
  trimDirective: function (value) {
    return value.replace(REGEX_DIRECTIVE, '')
  },
  regexCache: {},
  regexDirective: function (name) {
    // /(?:\/\*(?:!)?rtl:ignore(?::)?)([^]*?)(?:\*\/)/img
    this.regexCache[name] = this.regexCache[name] || new RegExp('(?:\\/\\*\\s*(?:!)?\\s*rtl:' + (name ? escapeRegExp(name) + '(?::)?' : '') + ')([^]*?)(?:\\*\\/)', 'img')
    return this.regexCache[name]
  },
  regex: function (what, options) {
    what = what || []
    var expression = ''
    for (var x = 0; x < what.length; x++) {
      switch (what[x]) {
        case 'percent':
          expression += '|(' + PATTERN_NUMBER + '%)'
          break
        case 'length':
          expression += '|(' + PATTERN_NUMBER + ')(?:ex|ch|r?em|vh|vw|vmin|vmax|px|mm|cm|in|pt|pc)?'
          break
        case 'number':
          expression += '|(' + PATTERN_NUMBER + ')'
          break
        case 'position':
          expression += '|(left|center|right|top|bottom)'
          break
        case 'calc':
          expression += '|(calc' + PATTERN_TOKEN + ')'
          break
      }
    }
    return new RegExp(expression.slice(1), options)
  },
  isLastOfType: function (node) {
    var isLast = true
    var next = node.next()
    while (next) {
      if (next && next.type === node.type) {
        isLast = false
        break
      }
      next = next.next()
    }
    return isLast
  },
  /**
   * Simple breakable each: returning false in the callback will break the loop
   * returns false if the loop was broken, otherwise true
   */
  each: function (array, callback) {
    for (var len = 0; len < array.length; len++) {
      if (callback(array[len]) === false) {
        return false
      }
    }
    return true
  }
}

module.exports.configure = function (configuration) {
  config = configuration
  return this
}


/***/ }),

/***/ "./src/@types/index.ts":
/*!*****************************!*\
  !*** ./src/@types/index.ts ***!
  \*****************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.Autorename = exports.Source = exports.Mode = void 0;
var Mode;
(function (Mode) {
    Mode["combined"] = "combined";
    Mode["override"] = "override";
})(Mode = exports.Mode || (exports.Mode = {}));
var Source;
(function (Source) {
    Source["ltr"] = "ltr";
    Source["rtl"] = "rtl";
})(Source = exports.Source || (exports.Source = {}));
var Autorename;
(function (Autorename) {
    Autorename["disabled"] = "disabled";
    Autorename["flexible"] = "flexible";
    Autorename["strict"] = "strict";
})(Autorename = exports.Autorename || (exports.Autorename = {}));


/***/ }),

/***/ "./src/constants/index.ts":
/*!********************************!*\
  !*** ./src/constants/index.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTROL_DIRECTIVE_BLOCK = exports.CONTROL_DIRECTIVE = exports.FLIP_PROPERTY_REGEXP = exports.RTL_CONTROL_DIRECTIVE_REG_EXP = exports.RTL_COMMENT_IGNORE_REGEXP = exports.RTL_COMMENT_REGEXP = exports.ANIMATION_NAME_PROP = exports.ANIMATION_PROP = exports.KEYFRAMES_NAME = exports.FUNCTION_TYPE = exports.BOOLEAN_TYPE = exports.STRING_TYPE = exports.AT_RULE_TYPE = exports.RULE_TYPE = exports.DECLARATION_TYPE = exports.COMMENT_TYPE = void 0;
exports.COMMENT_TYPE = 'comment';
exports.DECLARATION_TYPE = 'decl';
exports.RULE_TYPE = 'rule';
exports.AT_RULE_TYPE = 'atrule';
exports.STRING_TYPE = 'string';
exports.BOOLEAN_TYPE = 'boolean';
exports.FUNCTION_TYPE = 'function';
exports.KEYFRAMES_NAME = 'keyframes';
exports.ANIMATION_PROP = 'animation';
exports.ANIMATION_NAME_PROP = 'animation-name';
exports.RTL_COMMENT_REGEXP = /rtl:/;
exports.RTL_COMMENT_IGNORE_REGEXP = /rtl:ignore/;
exports.RTL_CONTROL_DIRECTIVE_REG_EXP = /^\/\*!? *rtl:?(begin|end)?:(\w+):?([^*]*?) *\*\/$/;
exports.FLIP_PROPERTY_REGEXP = /(right|left)/i;
var CONTROL_DIRECTIVE;
(function (CONTROL_DIRECTIVE) {
    CONTROL_DIRECTIVE["IGNORE"] = "ignore";
    CONTROL_DIRECTIVE["RENAME"] = "rename";
    CONTROL_DIRECTIVE["SOURCE"] = "source";
    CONTROL_DIRECTIVE["RAW"] = "raw";
})(CONTROL_DIRECTIVE = exports.CONTROL_DIRECTIVE || (exports.CONTROL_DIRECTIVE = {}));
var CONTROL_DIRECTIVE_BLOCK;
(function (CONTROL_DIRECTIVE_BLOCK) {
    CONTROL_DIRECTIVE_BLOCK["BEGIN"] = "begin";
    CONTROL_DIRECTIVE_BLOCK["END"] = "end";
})(CONTROL_DIRECTIVE_BLOCK = exports.CONTROL_DIRECTIVE_BLOCK || (exports.CONTROL_DIRECTIVE_BLOCK = {}));


/***/ }),

/***/ "./src/data/initial-values.json":
/*!**************************************!*\
  !*** ./src/data/initial-values.json ***!
  \**************************************/
/*! exports provided: 0, auto, currentcolor, medium, none, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"0\":[\"border-bottom-right-radius\",\"border-bottom-left-radius\",\"border-end-end-radius\",\"border-end-start-radius\",\"border-start-end-radius\",\"border-start-start-radius\",\"border-top-left-radius\",\"border-top-right-radius\",\"margin-block-end\",\"margin-block-start\",\"margin-top\",\"margin-right\",\"margin-bottom\",\"margin-left\",\"margin-inline-end\",\"margin-inline-start\",\"padding-block-end\",\"padding-block-start\",\"padding-top\",\"padding-right\",\"padding-bottom\",\"padding-left\",\"padding-inline-end\",\"padding-inline-start\",\"scroll-margin-block-end\",\"scroll-margin-block-start\",\"scroll-margin-top\",\"scroll-margin-right\",\"scroll-margin-bottom\",\"scroll-margin-left\",\"scroll-margin-inline-end\",\"scroll-margin-inline-start\"],\"auto\":[\"top\",\"right\",\"bottom\",\"left\",\"grid-column-end\",\"grid-column-start\",\"grid-row-end\",\"grid-row-start\",\"inset-block-end\",\"inset-block-start\",\"inset-inline-end\",\"inset-inline-start\",\"scroll-padding-block-end\",\"scroll-padding-block-start\",\"scroll-padding-top\",\"scroll-padding-right\",\"scroll-padding-bottom\",\"scroll-padding-left\",\"scroll-padding-inline-end\",\"scroll-padding-inline-start\"],\"currentcolor\":[\"border-block-start-color\",\"border-block-end-color\",\"border-top-color\",\"border-right-color\",\"border-bottom-color\",\"border-left-color\",\"border-inline-start-color\",\"border-inline-end-color\"],\"medium\":[\"border-block-start-width\",\"border-block-end-width\",\"border-top-width\",\"border-right-width\",\"border-bottom-width\",\"border-left-width\",\"border-inline-start-width\",\"border-inline-end-width\"],\"none\":[\"border-block-start\",\"border-block-end\",\"border-top\",\"border-right\",\"border-bottom\",\"border-left\",\"border-top-style\",\"border-right-style\",\"border-bottom-style\",\"border-left-style\",\"border-block-start-style\",\"border-block-end-style\",\"border-inline-start\",\"border-inline-end\",\"border-inline-start-style\",\"border-inline-end-style\"]}");

/***/ }),

/***/ "./src/data/not-shorthand-declarations.json":
/*!**************************************************!*\
  !*** ./src/data/not-shorthand-declarations.json ***!
  \**************************************************/
/*! exports provided: 0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, default */
/***/ (function(module) {

module.exports = JSON.parse("[\"box-shadow\",\"clear\",\"cursor\",\"direction\",\"float\",\"left\",\"right\",\"text-align\",\"text-align-last\",\"text-shadow\",\"transform\",\"transform-origin\"]");

/***/ }),

/***/ "./src/data/shorthand-declarations.json":
/*!**********************************************!*\
  !*** ./src/data/shorthand-declarations.json ***!
  \**********************************************/
/*! exports provided: animation, background, background-position, border, border-bottom, border-left, border-right, border-top, border-color, border-style, border-width, border-radius, margin, padding, transition, default */
/***/ (function(module) {

module.exports = JSON.parse("{\"animation\":{\"overridden\":null,\"overrides\":[\"animation-direction\",\"animation-duration\",\"animation-delay\",\"animation-name\",\"animation-fill-mode\",\"animation-iteration-count\",\"animation-play-state\",\"animation-timing-function\"]},\"background\":{\"overridden\":null,\"overrides\":[\"background-attachment\",\"background-clip\",\"background-color\",\"background-image\",\"background-repeat\",\"background-size\"]},\"background-position\":{\"overridden\":\"background\",\"overrides\":[\"background-position-x\",\"background-position-y\"]},\"border\":{\"overridden\":null,\"overrides\":[]},\"border-bottom\":{\"overridden\":\"border\",\"overrides\":[\"border-bottom-color\",\"border-bottom-style\",\"border-bottom-width\"]},\"border-left\":{\"overridden\":\"border\",\"overrides\":[\"border-left-color\",\"border-left-style\",\"border-left-width\"]},\"border-right\":{\"overridden\":\"border\",\"overrides\":[\"border-right-color\",\"border-right-style\",\"border-right-width\"]},\"border-top\":{\"overridden\":\"border\",\"overrides\":[\"border-top-color\",\"border-top-style\",\"border-top-width\"]},\"border-color\":{\"overridden\":\"border\",\"overrides\":[\"border-bottom-color\",\"border-left-color\",\"border-right-color\",\"border-top-color\"]},\"border-style\":{\"overridden\":\"border\",\"overrides\":[\"border-bottom-style\",\"border-left-style\",\"border-right-style\",\"border-top-style\"]},\"border-width\":{\"overridden\":\"border\",\"overrides\":[\"border-bottom-width\",\"border-left-width\",\"border-right-width\",\"border-top-width\"]},\"border-radius\":{\"overridden\":null,\"overrides\":[\"border-bottom-left-radius\",\"border-bottom-right-radius\",\"border-top-left-radius\",\"border-top-right-radius\"]},\"margin\":{\"overridden\":null,\"overrides\":[\"margin-bottom\",\"margin-left\",\"margin-top\",\"margin-right\"]},\"padding\":{\"overridden\":null,\"overrides\":[\"padding-bottom\",\"padding-left\",\"padding-top\",\"padding-right\"]},\"transition\":{\"overridden\":null,\"overrides\":[\"transition-delay\",\"transition-duration\",\"transition-property\",\"transition-timing-function\"]}}");

/***/ }),

/***/ "./src/data/store.ts":
/*!***************************!*\
  !*** ./src/data/store.ts ***!
  \***************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.initKeyframesData = exports.initStore = exports.store = exports.normalizeOptions = void 0;
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var atrules_1 = __webpack_require__(/*! @parsers/atrules */ "./src/parsers/atrules.ts");
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var defaultStringMap = [
    {
        name: 'left-right',
        search: ['left', 'Left', 'LEFT'],
        replace: ['right', 'Right', 'RIGHT']
    },
    {
        name: 'ltr-rtl',
        search: ['ltr', 'Ltr', 'LTR'],
        replace: ['rtl', 'Rtl', 'RTL'],
    }
];
var getStringMapName = function (map) {
    if (map.name) {
        return map.name;
    }
    var search = Array.isArray(map.search) ? map.search[0] : map.search;
    var replace = Array.isArray(map.replace) ? map.replace[0] : map.replace;
    var reg = /[^\w]/g;
    var searchName = search.replace(reg, '-');
    var replaceName = replace.replace(reg, '_');
    return searchName + "-" + replaceName;
};
var getRTLCSSStringMap = function (stringMap) {
    return stringMap.map(function (map) { return ({
        name: getStringMapName(map),
        priority: 100,
        search: map.search,
        replace: map.replace,
        options: {
            scope: '*',
            ignoreCase: false
        }
    }); });
};
var ModeValuesArray = Object.keys(_types_1.Mode).map(function (prop) { return _types_1.Mode[prop]; });
var SourceValuesArray = Object.keys(_types_1.Source).map(function (prop) { return _types_1.Source[prop]; });
var AutorenameValuesArray = Object.keys(_types_1.Autorename).map(function (prop) { return _types_1.Autorename[prop]; });
var isNotStringOrStringArray = function (value) {
    if (typeof value !== 'string' && !Array.isArray(value)) {
        return true;
    }
    if (Array.isArray(value)) {
        return value.some(function (item) { return typeof item !== 'string'; });
    }
    return false;
};
var isNotAcceptedStringMap = function (stringMap) {
    if (!Array.isArray(stringMap)) {
        return true;
    }
    return stringMap.some(function (map) {
        return typeof map.search !== typeof map.replace ||
            isNotStringOrStringArray(map.search) ||
            isNotStringOrStringArray(map.replace) ||
            (Array.isArray(map.search) &&
                Array.isArray(map.replace) &&
                map.search.length !== map.replace.length);
    });
};
var defaultOptions = function () { return ({
    mode: _types_1.Mode.combined,
    ltrPrefix: '[dir="ltr"]',
    rtlPrefix: '[dir="rtl"]',
    bothPrefix: '[dir]',
    safeBothPrefix: false,
    source: _types_1.Source.ltr,
    processUrls: false,
    processKeyFrames: false,
    useCalc: false,
    stringMap: getRTLCSSStringMap(defaultStringMap),
    autoRename: _types_1.Autorename.disabled,
    greedy: false,
    filter: function () { return false; },
    keyFrameFilter: function () { return false; },
}); };
var defaultKeyframesRegExp = new RegExp('$-^');
var store = {
    options: __assign({}, defaultOptions()),
    keyframes: [],
    keyframesStringMap: {},
    keyframesRegExp: defaultKeyframesRegExp,
    rules: [],
    rulesAutoRename: []
};
exports.store = store;
exports.normalizeOptions = function (options) {
    var returnOptions = __assign({}, defaultOptions());
    if (options.mode && ModeValuesArray.includes(options.mode)) {
        returnOptions.mode = options.mode;
    }
    if (options.source && SourceValuesArray.includes(options.source)) {
        returnOptions.source = options.source;
    }
    if (options.autoRename && AutorenameValuesArray.includes(options.autoRename)) {
        returnOptions.autoRename = options.autoRename;
    }
    if (typeof options.greedy === _constants_1.BOOLEAN_TYPE) {
        returnOptions.greedy = options.greedy;
    }
    if (!isNotStringOrStringArray(options.ltrPrefix)) {
        returnOptions.ltrPrefix = options.ltrPrefix;
    }
    if (!isNotStringOrStringArray(options.rtlPrefix)) {
        returnOptions.rtlPrefix = options.rtlPrefix;
    }
    if (!isNotStringOrStringArray(options.bothPrefix)) {
        returnOptions.bothPrefix = options.bothPrefix;
    }
    if (typeof options.safeBothPrefix === _constants_1.BOOLEAN_TYPE) {
        returnOptions.safeBothPrefix = options.safeBothPrefix;
    }
    if (typeof options.processUrls === _constants_1.BOOLEAN_TYPE) {
        returnOptions.processUrls = options.processUrls;
    }
    if (typeof options.processKeyFrames === _constants_1.BOOLEAN_TYPE) {
        returnOptions.processKeyFrames = options.processKeyFrames;
    }
    if (typeof options.useCalc === _constants_1.BOOLEAN_TYPE) {
        returnOptions.useCalc = options.useCalc;
    }
    if (typeof options.filter === _constants_1.FUNCTION_TYPE) {
        returnOptions.filter = options.filter;
    }
    if (typeof options.keyFrameFilter === _constants_1.FUNCTION_TYPE) {
        returnOptions.keyFrameFilter = options.keyFrameFilter;
    }
    if (!isNotAcceptedStringMap(options.stringMap)) {
        var stringMap = getRTLCSSStringMap(options.stringMap);
        stringMap.forEach(function (map) {
            if (map.name === defaultStringMap[0].name) {
                returnOptions.stringMap.splice(0, 1, map);
            }
            else if (map.name === defaultStringMap[1].name) {
                returnOptions.stringMap.splice(1, 1, map);
            }
            else {
                returnOptions.stringMap.push(map);
            }
        });
    }
    return returnOptions;
};
var initStore = function (options) {
    store.options = exports.normalizeOptions(options);
    store.keyframes = [];
    store.keyframesStringMap = {};
    store.keyframesRegExp = defaultKeyframesRegExp;
    store.rules = [];
    store.rulesAutoRename = [];
};
exports.initStore = initStore;
var initKeyframesData = function () {
    store.keyframesStringMap = atrules_1.getKeyFramesStringMap(store.keyframes);
    store.keyframesRegExp = atrules_1.getKeyFramesRegExp(store.keyframesStringMap);
};
exports.initKeyframesData = initKeyframesData;


/***/ }),

/***/ "./src/index.ts":
/*!**********************!*\
  !*** ./src/index.ts ***!
  \**********************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var rtl_css_1 = __webpack_require__(/*! ./rtl-css */ "./src/rtl-css/index.ts");
Object.defineProperty(exports, "postcssRTLCSS", { enumerable: true, get: function () { return rtl_css_1.postcssRTLCSS; } });
Object.defineProperty(exports, "postcss", { enumerable: true, get: function () { return rtl_css_1.postcss; } });
var rtl_react_1 = __webpack_require__(/*! ./rtl-react */ "./src/rtl-react/index.ts");
Object.defineProperty(exports, "reactRTLJsInit", { enumerable: true, get: function () { return rtl_react_1.reactRTLJsInit; } });
Object.defineProperty(exports, "reactPropsProcessor", { enumerable: true, get: function () { return rtl_react_1.reactPropsProcessor; } });
Object.defineProperty(exports, "processor", { enumerable: true, get: function () { return rtl_react_1.processor; } });
Object.defineProperty(exports, "processorForNew", { enumerable: true, get: function () { return rtl_react_1.processorForNew; } });
Object.defineProperty(exports, "createElement", { enumerable: true, get: function () { return rtl_react_1.createElement; } });
Object.defineProperty(exports, "rtlCssReact", { enumerable: true, get: function () { return rtl_react_1.rtlCssReact; } });
Object.defineProperty(exports, "RTLSkipStart", { enumerable: true, get: function () { return rtl_react_1.RTLSkipStart; } });
Object.defineProperty(exports, "RTLSkipEnd", { enumerable: true, get: function () { return rtl_react_1.RTLSkipEnd; } });
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
Object.defineProperty(exports, "setRTLStatus", { enumerable: true, get: function () { return index_1.setRTLStatus; } });
var _types_1 = __webpack_require__(/*! ./@types */ "./src/@types/index.ts");
Object.defineProperty(exports, "Mode", { enumerable: true, get: function () { return _types_1.Mode; } });
Object.defineProperty(exports, "Source", { enumerable: true, get: function () { return _types_1.Source; } });
Object.defineProperty(exports, "Autorename", { enumerable: true, get: function () { return _types_1.Autorename; } });


/***/ }),

/***/ "./src/parsers/atrules.ts":
/*!********************************!*\
  !*** ./src/parsers/atrules.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseKeyFrames = exports.parseAtRules = exports.getKeyFramesRegExp = exports.getKeyFramesStringMap = void 0;
var postcss_1 = __importDefault(__webpack_require__(/*! postcss */ "postcss"));
var rtlcss_1 = __importDefault(__webpack_require__(/*! rtlcss */ "./node_modules/rtlcss/lib/rtlcss.js"));
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
var containers_1 = __webpack_require__(/*! @utilities/containers */ "./src/utilities/containers.ts");
var directives_1 = __webpack_require__(/*! @utilities/directives */ "./src/utilities/directives.ts");
var rules_1 = __webpack_require__(/*! @parsers/rules */ "./src/parsers/rules.ts");
var vendor_1 = __webpack_require__(/*! @utilities/vendor */ "./src/utilities/vendor.ts");
exports.getKeyFramesStringMap = function (keyframes) {
    var stringMap = {};
    keyframes.forEach(function (obj) {
        stringMap[obj.atRuleParams] = {
            name: obj.atRule.params,
            nameFlipped: obj.atRuleFlipped.params
        };
    });
    return stringMap;
};
exports.getKeyFramesRegExp = function (stringMap) { return new RegExp("(^|[^\\w-]| )(" + Object.keys(stringMap).join('|') + ")( |[^\\w-]|$)", 'g'); };
exports.parseAtRules = function (css) {
    var controlDirectives = {};
    containers_1.walkContainer(css, [_constants_1.AT_RULE_TYPE, _constants_1.RULE_TYPE], function (_comment, controlDirective) {
        if (directives_1.isIgnoreDirectiveInsideAnIgnoreBlock(controlDirective, controlDirectives)) {
            return;
        }
        controlDirectives[controlDirective.directive] = controlDirective;
    }, function (node) {
        if (directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.IGNORE)) {
            return;
        }
        if (node.type !== _constants_1.AT_RULE_TYPE)
            return;
        var atRule = node;
        if (vendor_1.vendor.unprefixed(atRule.name) === _constants_1.KEYFRAMES_NAME)
            return;
        var sourceDirectiveValue = directives_1.getSourceDirectiveValue(controlDirectives);
        rules_1.parseRules(atRule, sourceDirectiveValue);
    });
};
exports.parseKeyFrames = function (css) {
    var _a = store_1.store.options, source = _a.source, processUrls = _a.processUrls, useCalc = _a.useCalc, stringMap = _a.stringMap, processKeyFrames = _a.processKeyFrames;
    if (!processKeyFrames) {
        return;
    }
    var controlDirectives = {};
    containers_1.walkContainer(css, [_constants_1.AT_RULE_TYPE, _constants_1.RULE_TYPE], function (_comment, controlDirective) {
        if (directives_1.isIgnoreDirectiveInsideAnIgnoreBlock(controlDirective, controlDirectives)) {
            return;
        }
        controlDirectives[controlDirective.directive] = controlDirective;
    }, function (node) {
        var _a, _b, _c;
        if (directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.IGNORE)) {
            return;
        }
        var rule = node;
        if (node.type !== _constants_1.AT_RULE_TYPE)
            return;
        try {
            var file = (_c = (_b = (_a = rule.source) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.replace(/-rtl$/, '');
            if (store_1.store.options.keyFrameFilter(file))
                return;
        }
        catch (e) {
            console.log('error');
        }
        var atRule = node;
        if (vendor_1.vendor.unprefixed(atRule.name) !== _constants_1.KEYFRAMES_NAME)
            return;
        var atRuleString = atRule.toString();
        var atRuleFlippedString = rtlcss_1.default.process(atRuleString, { processUrls: processUrls, useCalc: useCalc, stringMap: stringMap });
        if (atRuleString === atRuleFlippedString)
            return;
        var rootFlipped = postcss_1.default.parse(atRuleFlippedString);
        var atRuleFlipped = rootFlipped.first;
        var atRuleParams = atRule.params;
        var ltr = atRuleParams + "-" + _types_1.Source.ltr;
        var rtl = atRuleParams + "-" + _types_1.Source.rtl;
        var sourceDirectiveValue = directives_1.getSourceDirectiveValue(controlDirectives);
        atRule.params = ((!sourceDirectiveValue &&
            source === _types_1.Source.ltr) ||
            (sourceDirectiveValue &&
                sourceDirectiveValue === _types_1.Source.ltr))
            ? ltr
            : rtl;
        atRuleFlipped.params = ((!sourceDirectiveValue &&
            source === _types_1.Source.ltr) ||
            (sourceDirectiveValue &&
                sourceDirectiveValue === _types_1.Source.ltr))
            ? rtl
            : ltr;
        store_1.store.keyframes.push({
            atRuleParams: atRuleParams,
            atRule: atRule,
            atRuleFlipped: atRuleFlipped
        });
    });
    store_1.initKeyframesData();
};


/***/ }),

/***/ "./src/parsers/declarations.ts":
/*!*************************************!*\
  !*** ./src/parsers/declarations.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseDeclarations = void 0;
var postcss_1 = __importDefault(__webpack_require__(/*! postcss */ "postcss"));
var rtlcss_1 = __importDefault(__webpack_require__(/*! rtlcss */ "./node_modules/rtlcss/lib/rtlcss.js"));
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
var vendor_1 = __webpack_require__(/*! @utilities/vendor */ "./src/utilities/vendor.ts");
var directives_1 = __webpack_require__(/*! @utilities/directives */ "./src/utilities/directives.ts");
var declarations_1 = __webpack_require__(/*! @utilities/declarations */ "./src/utilities/declarations.ts");
var containers_1 = __webpack_require__(/*! @utilities/containers */ "./src/utilities/containers.ts");
var rules_1 = __webpack_require__(/*! @utilities/rules */ "./src/utilities/rules.ts");
exports.parseDeclarations = function (rule, hasParentRule, ruleSourceDirectiveValue, autorenamed) {
    if (autorenamed === void 0) { autorenamed = false; }
    var _a = store_1.store.options, mode = _a.mode, source = _a.source, safeBothPrefix = _a.safeBothPrefix, processUrls = _a.processUrls, useCalc = _a.useCalc, stringMap = _a.stringMap, autoRename = _a.autoRename, greedy = _a.greedy;
    var deleteDeclarations = [];
    var ruleFlipped = rule.clone().removeAll();
    var ruleFlippedSecond = ruleFlipped.clone();
    var ruleBoth = ruleFlipped.clone();
    var ruleSafe = ruleFlipped.clone();
    var declarationHashMap = Array.prototype.reduce.call(rule.nodes, function (obj, node) {
        if (node.type === _constants_1.DECLARATION_TYPE) {
            var decl = node;
            obj[decl.prop] = decl.value.trim();
        }
        return obj;
    }, {});
    var declarationsProps = [];
    var simetricRules = false;
    var controlDirectives = {};
    containers_1.walkContainer(rule, [_constants_1.DECLARATION_TYPE], function (comment, controlDirective) {
        rules_1.cleanRuleRawsBefore(comment.next());
        comment.remove();
        if (controlDirective.directive === _constants_1.CONTROL_DIRECTIVE.RAW &&
            controlDirective.option) {
            var sourceDirectiveValue = directives_1.getSourceDirectiveValue(controlDirectives, ruleSourceDirectiveValue);
            var root = postcss_1.default.parse(controlDirective.option);
            if ((mode === _types_1.Mode.combined &&
                !sourceDirectiveValue) ||
                (sourceDirectiveValue &&
                    ((mode === _types_1.Mode.combined &&
                        sourceDirectiveValue === source) ||
                        (mode !== _types_1.Mode.combined &&
                            sourceDirectiveValue !== source)))) {
                ruleFlippedSecond.append(root.nodes);
            }
            else {
                ruleFlipped.append(root.nodes);
            }
        }
        if (directives_1.isIgnoreDirectiveInsideAnIgnoreBlock(controlDirective, controlDirectives)) {
            return;
        }
        controlDirectives[controlDirective.directive] = controlDirective;
    }, function (node) {
        if (directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.IGNORE)) {
            return;
        }
        var processUrlDirective = directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.RENAME);
        var decl = node;
        var declString = decl.toString() + ";";
        var declFlippedString = rtlcss_1.default.process(declString, {
            processUrls: processUrls || processUrlDirective,
            useCalc: useCalc,
            stringMap: stringMap,
            autoRename: autoRename !== _types_1.Autorename.disabled,
            autoRenameStrict: autoRename === _types_1.Autorename.strict,
            greedy: greedy
        });
        var root = postcss_1.default.parse(declFlippedString);
        var declFlipped = root.first;
        declFlipped.raws = decl.raws;
        var declProp = decl.prop.trim();
        var declPropUnprefixed = vendor_1.vendor.unprefixed(declProp);
        var declValue = decl.value.trim();
        var isAnimation = declPropUnprefixed === _constants_1.ANIMATION_PROP || declPropUnprefixed === _constants_1.ANIMATION_NAME_PROP;
        var declFlippedProp = declFlipped.prop.trim();
        var declFlippedValue = declFlipped.value.trim();
        var overridenBy = declarations_1.declarations[declPropUnprefixed];
        var hasBeenOverriden = overridenBy
            ? overridenBy.some(function (d) { return declarationsProps.indexOf(d) >= 0; })
            : false;
        var isConflictedDeclaration = safeBothPrefix
            ? !!declarations_1.allDeclarations[declPropUnprefixed]
            : false;
        var sourceDirectiveValue = directives_1.getSourceDirectiveValue(controlDirectives, ruleSourceDirectiveValue);
        var normalFlip = !sourceDirectiveValue || sourceDirectiveValue === source;
        if (!hasBeenOverriden &&
            !isConflictedDeclaration &&
            declProp === declFlippedProp &&
            declValue === declFlippedValue &&
            !isAnimation) {
            return;
        }
        if (isAnimation) {
            if (declProp === declFlippedProp &&
                declValue === declFlippedValue &&
                (store_1.store.keyframes.length === 0 ||
                    !store_1.store.keyframesRegExp.test(declValue))) {
                if (safeBothPrefix && !declarations_1.hasIgnoreDirectiveInRaws(decl)) {
                    declarations_1.appendDeclarationToRule(decl, ruleSafe);
                    deleteDeclarations.push(decl);
                }
            }
            else {
                var animationDeclValue = decl.value.replace(store_1.store.keyframesRegExp, function (_match, before, animation, after) {
                    return before + store_1.store.keyframesStringMap[animation].name + after;
                });
                var animationDeclValueFlipped = decl.value.replace(store_1.store.keyframesRegExp, function (_match, before, animation, after) {
                    return before + store_1.store.keyframesStringMap[animation].nameFlipped + after;
                });
                var declCloneFlipped = decl.clone();
                if (mode === _types_1.Mode.combined) {
                    var declClone = decl.clone();
                    declClone.value = animationDeclValue;
                    declCloneFlipped.value = animationDeclValueFlipped;
                    if (normalFlip) {
                        ruleFlipped.append(declClone);
                        ruleFlippedSecond.append(declCloneFlipped);
                    }
                    else {
                        ruleFlipped.append(declCloneFlipped);
                        ruleFlippedSecond.append(declClone);
                    }
                    deleteDeclarations.push(decl);
                }
                else {
                    var declCloneFlipped_1 = decl.clone();
                    decl.value = animationDeclValue;
                    declCloneFlipped_1.value = animationDeclValueFlipped;
                    if (normalFlip) {
                        ruleFlipped.append(declCloneFlipped_1);
                    }
                    else {
                        ruleFlippedSecond.append(declCloneFlipped_1);
                    }
                    if (safeBothPrefix) {
                        declarations_1.appendDeclarationToRule(decl, ruleSafe);
                        deleteDeclarations.push(decl);
                    }
                }
            }
        }
        else {
            if (declProp === declFlippedProp &&
                declValue === declFlippedValue) {
                if ((hasBeenOverriden || isConflictedDeclaration) && !declarations_1.hasIgnoreDirectiveInRaws(decl)) {
                    declarations_1.appendDeclarationToRule(decl, hasBeenOverriden ? ruleBoth : ruleSafe);
                    deleteDeclarations.push(decl);
                }
                return;
            }
            else if (declarationHashMap[declFlipped.prop] === declFlippedValue) {
                simetricRules = true;
                if (isConflictedDeclaration && !declarations_1.hasIgnoreDirectiveInRaws(decl)) {
                    declarations_1.appendDeclarationToRule(decl, ruleSafe);
                    deleteDeclarations.push(decl);
                }
                return;
            }
            if (mode === _types_1.Mode.combined) {
                if (normalFlip) {
                    declarations_1.appendDeclarationToRule(decl, ruleFlipped);
                    ruleFlippedSecond.append(declFlipped);
                }
                else {
                    declarations_1.appendDeclarationToRule(decl, ruleFlippedSecond);
                    ruleFlipped.append(declFlipped);
                }
                deleteDeclarations.push(decl);
            }
            else {
                if (_constants_1.FLIP_PROPERTY_REGEXP.test(decl.prop) && !declarationHashMap[declFlipped.prop]) {
                    var declClone = decl.clone();
                    declClone.value = declarations_1.initialValues[decl.prop] || 'unset';
                    if (normalFlip) {
                        ruleFlipped.append(declClone);
                    }
                    else {
                        ruleFlippedSecond.append(declClone);
                    }
                }
                if (isConflictedDeclaration && !declarations_1.hasIgnoreDirectiveInRaws(decl)) {
                    declarations_1.appendDeclarationToRule(decl, ruleSafe);
                    deleteDeclarations.push(decl);
                }
                if (normalFlip) {
                    ruleFlipped.append(declFlipped);
                }
                else {
                    ruleFlippedSecond.append(declFlipped);
                }
            }
            declarationsProps.push(declPropUnprefixed);
        }
    });
    if (deleteDeclarations.length) {
        deleteDeclarations.forEach(function (decl) { return decl.remove(); });
    }
    if (ruleFlipped.nodes.length ||
        ruleFlippedSecond.nodes.length ||
        ruleBoth.nodes.length ||
        ruleSafe.nodes.length) {
        if (hasParentRule) {
            rules_1.appendParentRuleToStore(rule, ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe);
        }
        else {
            rules_1.insertRuleIntoStore(rule, ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe);
        }
    }
    else if (autoRename !== _types_1.Autorename.disabled &&
        !simetricRules &&
        !autorenamed) {
        store_1.store.rulesAutoRename.push(rule);
    }
};


/***/ }),

/***/ "./src/parsers/rules.ts":
/*!******************************!*\
  !*** ./src/parsers/rules.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseRules = void 0;
var postcss_1 = __importDefault(__webpack_require__(/*! postcss */ "postcss"));
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
var directives_1 = __webpack_require__(/*! @utilities/directives */ "./src/utilities/directives.ts");
var containers_1 = __webpack_require__(/*! @utilities/containers */ "./src/utilities/containers.ts");
var rules_1 = __webpack_require__(/*! @utilities/rules */ "./src/utilities/rules.ts");
var selectors_1 = __webpack_require__(/*! @utilities/selectors */ "./src/utilities/selectors.ts");
var declarations_1 = __webpack_require__(/*! ./declarations */ "./src/parsers/declarations.ts");
exports.parseRules = function (container, parentSourceDirective, hasParentRule) {
    if (parentSourceDirective === void 0) { parentSourceDirective = undefined; }
    if (hasParentRule === void 0) { hasParentRule = false; }
    var controlDirectives = {};
    var _a = store_1.store.options, source = _a.source, ltrPrefix = _a.ltrPrefix, rtlPrefix = _a.rtlPrefix;
    containers_1.walkContainer(container, [_constants_1.RULE_TYPE], function (comment, controlDirective) {
        if (controlDirective.directive === _constants_1.CONTROL_DIRECTIVE.RAW &&
            controlDirective.option) {
            var sourceDirectiveValue_1 = directives_1.getSourceDirectiveValue(controlDirectives);
            var root = postcss_1.default.parse(controlDirective.option);
            root.walkRules(function (rule) {
                selectors_1.addSelectorPrefixes(rule, ((!sourceDirectiveValue_1 &&
                    source === _types_1.Source.ltr) ||
                    (sourceDirectiveValue_1 &&
                        sourceDirectiveValue_1 === _types_1.Source.ltr))
                    ? rtlPrefix
                    : ltrPrefix);
            });
            comment.replaceWith(root.nodes);
            return;
        }
        rules_1.cleanRuleRawsBefore(comment.next());
        comment.remove();
        if (directives_1.isIgnoreDirectiveInsideAnIgnoreBlock(controlDirective, controlDirectives)) {
            return;
        }
        controlDirectives[controlDirective.directive] = controlDirective;
    }, function (node) {
        var _a, _b, _c;
        if (directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.IGNORE)) {
            return;
        }
        var rule = node;
        try {
            var file = (_c = (_b = (_a = rule.source) === null || _a === void 0 ? void 0 : _a.input) === null || _b === void 0 ? void 0 : _b.file) === null || _c === void 0 ? void 0 : _c.replace(/-rtl$/, '');
            var selector = rule.selector;
            if (selector.includes('[dir="rtl"]') || selector.includes("[dir='rtl']"))
                return;
            if (store_1.store.options.filter(file, selector))
                return;
        }
        catch (e) {
            console.log('error');
        }
        var sourceDirectiveValue = directives_1.getSourceDirectiveValue(controlDirectives, parentSourceDirective);
        if (directives_1.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.RENAME)) {
            store_1.store.rulesAutoRename.push(rule);
            declarations_1.parseDeclarations(rule, hasParentRule, sourceDirectiveValue, true);
        }
        else {
            declarations_1.parseDeclarations(rule, hasParentRule, sourceDirectiveValue);
        }
        exports.parseRules(rule, parentSourceDirective, true);
    });
};


/***/ }),

/***/ "./src/rtl-css/index.ts":
/*!******************************!*\
  !*** ./src/rtl-css/index.ts ***!
  \******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.postcss = exports.postcssRTLCSS = void 0;
var postcss_1 = __importDefault(__webpack_require__(/*! postcss */ "postcss"));
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
var atrules_1 = __webpack_require__(/*! @parsers/atrules */ "./src/parsers/atrules.ts");
var rules_1 = __webpack_require__(/*! @parsers/rules */ "./src/parsers/rules.ts");
var rules_2 = __webpack_require__(/*! @utilities/rules */ "./src/utilities/rules.ts");
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
Object.defineProperty(exports, "Mode", { enumerable: true, get: function () { return _types_1.Mode; } });
Object.defineProperty(exports, "Source", { enumerable: true, get: function () { return _types_1.Source; } });
Object.defineProperty(exports, "Autorename", { enumerable: true, get: function () { return _types_1.Autorename; } });
var transformer = function (options) {
    if (options === void 0) { options = {}; }
    return (function (css) {
        store_1.initStore(options);
        atrules_1.parseKeyFrames(css);
        atrules_1.parseAtRules(css);
        rules_1.parseRules(css);
        rules_2.appendRules();
        rules_2.appendKeyFrames();
        rules_2.appendAutorenameRules();
    });
};
exports.postcssRTLCSS = postcss_1.default.plugin('postcss-rtlcss', transformer);
exports.postcss = {
    postcssPlugin: 'postcss-rtlcss',
    Once: function (css) {
        store_1.initStore({});
        atrules_1.parseKeyFrames(css);
        atrules_1.parseAtRules(css);
        rules_1.parseRules(css);
        rules_2.appendRules();
        rules_2.appendKeyFrames();
        rules_2.appendAutorenameRules();
    }
};


/***/ }),

/***/ "./src/rtl-react/index.ts":
/*!********************************!*\
  !*** ./src/rtl-react/index.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !exports.hasOwnProperty(p)) __createBinding(exports, m, p);
};
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createElement = exports.reactRTLJsInit = exports.processorForNew = exports.processor = exports.reactChildrenProcessor = exports.reactPropsProcessor = void 0;
var plugins_1 = __webpack_require__(/*! ./plugins */ "./src/rtl-react/plugins.ts");
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
var plugins_2 = __webpack_require__(/*! ./plugins */ "./src/rtl-react/plugins.ts");
Object.defineProperty(exports, "rtlCssReact", { enumerable: true, get: function () { return plugins_2.rtlCssReact; } });
__exportStar(__webpack_require__(/*! ./skip */ "./src/rtl-react/skip.ts"), exports);
exports.reactPropsProcessor = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return props;
    if (index_1.skipCSSProcess && (props === null || props === void 0 ? void 0 : props.className)) {
        index_1.addDisabledClassName(props.className);
        return props;
    }
    if ((props === null || props === void 0 ? void 0 : props.className) && index_1.isDisabledClassName(props === null || props === void 0 ? void 0 : props.className))
        return props;
    return plugins_1.propsPluginList.reduce(function (pre, cur) {
        return cur.apply(void 0, __spreadArrays([pre], children));
    }, props);
};
exports.reactChildrenProcessor = function () {
    var children = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        children[_i] = arguments[_i];
    }
    if (!index_1.isRTL)
        return children;
    return plugins_1.childrenPluginList.reduce(function (pre, cur) {
        return cur.apply(void 0, pre);
    }, children);
};
exports.processor = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return __spreadArrays([props], children);
    var newProps = exports.reactPropsProcessor.apply(void 0, __spreadArrays([props], children));
    var newChildren = exports.reactChildrenProcessor.apply(void 0, children);
    return __spreadArrays([newProps], newChildren);
};
exports.processorForNew = function (props) {
    var children = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        children[_i - 1] = arguments[_i];
    }
    if (!index_1.isRTL)
        return props;
    var newProps = exports.reactPropsProcessor.apply(void 0, __spreadArrays([props], children));
    var newChildren = exports.reactChildrenProcessor.apply(void 0, children);
    if ((newChildren === null || newChildren === void 0 ? void 0 : newChildren.length) === 1) {
        newProps.children = newChildren[0];
    }
    if ((newChildren === null || newChildren === void 0 ? void 0 : newChildren.length) > 1) {
        newProps.children = newChildren;
    }
    return newProps;
};
var stashCreateElement;
exports.reactRTLJsInit = function (react, option) {
    index_1.initRuntimeOption(option, react);
    var createElement = react.createElement;
    var newCreateElement = (function (type, props) {
        var children = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            children[_i - 2] = arguments[_i];
        }
        var _a = exports.processor.apply(void 0, __spreadArrays([props], children)), newProps = _a[0], newChildren = _a.slice(1);
        return createElement.apply(void 0, __spreadArrays([type, newProps], newChildren));
    });
    stashCreateElement = newCreateElement;
    react.createElement = newCreateElement;
};
exports.createElement = function () {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return stashCreateElement.apply(void 0, args);
};


/***/ }),

/***/ "./src/rtl-react/plugins.ts":
/*!**********************************!*\
  !*** ./src/rtl-react/plugins.ts ***!
  \**********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.childrenPluginList = exports.propsPluginList = exports.processPercentPlugin = exports.processIsRTLPropPlugin = exports.processCssPlugin = exports.rtlCssReact = void 0;
var config_1 = __webpack_require__(/*! @utilities/config */ "./src/utilities/config.ts");
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
exports.rtlCssReact = function (css) {
    var newCss = {};
    var cssPropList = Object.keys(css);
    for (var _i = 0, cssPropList_1 = cssPropList; _i < cssPropList_1.length; _i++) {
        var cssProp = cssPropList_1[_i];
        var cssValue = css[cssProp];
        var processedCss = config_1.process(cssProp, cssValue);
        newCss[processedCss.prop] = processedCss.value;
    }
    return newCss;
};
exports.processCssPlugin = function (props) {
    if (!(props === null || props === void 0 ? void 0 : props.style))
        return props;
    if (props === null || props === void 0 ? void 0 : props['data-rtl-disabled'])
        return props;
    return __assign(__assign({}, props), { style: exports.rtlCssReact(props.style) });
};
exports.processIsRTLPropPlugin = function (props) {
    if (!(props === null || props === void 0 ? void 0 : props['data-rtl']))
        return props;
    var css = props.style || {};
    var transform = css.transform || '';
    var hadScale = transform.includes(config_1.scaleCss);
    var newCss = __assign(__assign({}, css), { transform: hadScale ? transform : transform + " " + config_1.scaleCss });
    return __assign(__assign({}, props), { style: newCss });
};
var ignoreTypes = ['object', 'function', 'symbol'];
exports.processPercentPlugin = function () {
    var children = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        children[_i] = arguments[_i];
    }
    if (index_1.isBlank(children === null || children === void 0 ? void 0 : children[0]))
        return children;
    var newChildren = [];
    if (!/([\d.,]*\d)(%)/g.test(children.join('')))
        return children;
    var skip = false;
    for (var i = 0, len = children.length; i < len; i++) {
        var childrenType = typeof children[i];
        if (ignoreTypes.includes(childrenType)) {
            newChildren.push(children[i]);
            continue;
        }
        if (skip) {
            skip = false;
            continue;
        }
        var curChild = "" + children[i];
        var nextChild = "" + children[i + 1];
        var curIsMatch = /([\d.,]*\d)(%)/g.test(curChild);
        var nextIsMatch = /([\d.,]*\d)(%)/g.test(nextChild);
        if (curIsMatch) {
            newChildren.push(curChild.replace(/([\d.,]*\d)(%)/g, function (str, num, sign) {
                return "" + sign + num;
            }));
            continue;
        }
        if (!curIsMatch && !nextIsMatch && /([\d.,]*\d)(%)/g.test("" + curChild + nextChild)) {
            newChildren.push(("" + curChild + nextChild).replace(/([\d.,]*\d)(%)/g, function (str, num, sign) {
                return "" + sign + num;
            }));
            skip = true;
            continue;
        }
        newChildren.push(curChild);
    }
    return newChildren;
};
exports.propsPluginList = [
    exports.processCssPlugin,
    exports.processIsRTLPropPlugin,
];
exports.childrenPluginList = [
    exports.processPercentPlugin
];


/***/ }),

/***/ "./src/rtl-react/skip.ts":
/*!*******************************!*\
  !*** ./src/rtl-react/skip.ts ***!
  \*******************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTLSkipEnd = exports.RTLSkipStart = void 0;
var react_1 = __importDefault(__webpack_require__(/*! react */ "react"));
var index_1 = __webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts");
exports.RTLSkipStart = function () {
    index_1.setSkipStatus(true);
    return react_1.default.createElement(react_1.default.Fragment, null);
};
exports.RTLSkipEnd = function () {
    index_1.setSkipStatus(false);
    return react_1.default.createElement(react_1.default.Fragment, null);
};


/***/ }),

/***/ "./src/utilities/config.ts":
/*!*********************************!*\
  !*** ./src/utilities/config.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.scaleCss = exports.process = exports.processorList = void 0;
var index_1 = __importStar(__webpack_require__(/*! @utilities/index */ "./src/utilities/index.ts"));
exports.processorList = [
    {
        name: 'variable',
        expr: /^--/im,
        action: function (prop, value) {
            return { prop: prop, value: value };
        },
    },
    {
        name: 'direction',
        expr: /direction/im,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLtrRtl(value) };
        },
    },
    {
        name: 'left',
        expr: /left/im,
        action: function (prop, value) {
            return {
                prop: prop.replace(this.expr, function () {
                    if (prop.includes('-left') || prop === 'left') {
                        return 'right';
                    }
                    return 'Right';
                }),
                value: value,
            };
        },
    },
    {
        name: 'right',
        expr: /right/im,
        action: function (prop, value) {
            return {
                prop: prop.replace(this.expr, function () {
                    if (prop.includes('-right') || prop === 'right') {
                        return 'left';
                    }
                    return 'Left';
                }),
                value: value,
            };
        },
    },
    {
        name: 'four-value syntax',
        expr: /^(margin|padding|border-(color|style|width))$/gi,
        cache: null,
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: /[^\s\uFFFD]+/g,
                };
            }
            var state = index_1.default.guardFunctions(value);
            if (typeof value === 'number') {
                return { prop: prop, value: index_1.default.unguardFunctions(state) };
            }
            var result = state.value.match(this.cache.match);
            if (result &&
                result.length === 4 &&
                (state.store.length > 0 || result[1] !== result[3])) {
                var i_1 = 0;
                state.value = state.value.replace(this.cache.match, function () {
                    return result[(4 - i_1++) % 4];
                });
            }
            return { prop: prop, value: index_1.default.unguardFunctions(state) };
        },
    },
    {
        name: 'border radius',
        expr: /border-radius/gi,
        cache: null,
        flip: function (value) {
            var parts = value.match(this.cache.match);
            var i;
            if (parts) {
                switch (parts.length) {
                    case 2:
                        i = 1;
                        if (parts[0] !== parts[1]) {
                            value = value.replace(this.cache.match, function () {
                                return parts[i--];
                            });
                        }
                        break;
                    case 3:
                        value = value.replace(this.cache.white, function (m) {
                            return m + parts[1] + ' ';
                        });
                        break;
                    case 4:
                        i = 0;
                        if (parts[0] !== parts[1] || parts[2] !== parts[3]) {
                            value = value.replace(this.cache.match, function () {
                                return parts[(5 - i++) % 4];
                            });
                        }
                        break;
                }
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: /[^\s\uFFFD]+/g,
                    slash: /[^\/]+/g,
                    white: /(^\s*)/,
                };
            }
            var state = index_1.default.guardFunctions(value);
            state.value = state.value.replace(this.cache.slash, function (m) {
                return this.flip(m);
            }.bind(this));
            return { prop: prop, value: index_1.default.unguardFunctions(state) };
        },
    },
    {
        name: 'shadow',
        expr: /shadow/gi,
        cache: null,
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    replace: /[^,]+/g,
                };
            }
            var colorSafe = index_1.default.guardHexColors(value);
            var funcSafe = index_1.default.guardFunctions(colorSafe.value);
            funcSafe.value = funcSafe.value.replace(this.cache.replace, function (m) {
                return index_1.default.negate(m);
            });
            colorSafe.value = index_1.default.unguardFunctions(funcSafe);
            return { prop: prop, value: index_1.default.unguardHexColors(colorSafe) };
        },
    },
    {
        name: 'transform and perspective origin',
        expr: /(?:transform|perspective)-origin/gi,
        cache: null,
        flip: function (value) {
            if (value === '0') {
                value = '100%';
            }
            else if (value.match(this.cache.percent)) {
                value = index_1.default.complement(value);
            }
            else if (value.match(this.cache.length)) {
                value = index_1.default.flipLength(value);
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: index_1.default.regex(['calc', 'percent', 'length'], 'g'),
                    percent: index_1.default.regex(['calc', 'percent'], 'i'),
                    length: index_1.default.regex(['length'], 'gi'),
                    xKeyword: /(left|right)/i,
                };
            }
            if (value.match(this.cache.xKeyword)) {
                value = index_1.default.swapLeftRight(value);
            }
            else {
                var state = index_1.default.guardFunctions(value);
                var parts_1 = state.value.match(this.cache.match);
                if (parts_1 && parts_1.length > 0) {
                    parts_1[0] = this.flip(parts_1[0]);
                    state.value = state.value.replace(this.cache.match, function () {
                        return parts_1.shift();
                    });
                    value = index_1.default.unguardFunctions(state);
                }
            }
            return { prop: prop, value: value };
        },
    },
    {
        name: 'transform',
        expr: /^(?!text\-).*?transform$/gi,
        cache: null,
        flip: function (value, process) {
            var i = 0;
            return value.replace(this.cache.unit, function (num) {
                return process(++i, num);
            });
        },
        flipMatrix: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 2 || i === 3 || i === 5) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        flipMatrix3D: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 2 || i === 4 || i === 5 || i === 13) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        flipRotate3D: function (value) {
            return this.flip(value, function (i, num) {
                if (i === 1 || i === 4) {
                    return index_1.default.negate(num);
                }
                return num;
            });
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    negatable: /((translate)(x|3d)?|rotate(z|y)?)$/gi,
                    unit: index_1.default.regex(['calc', 'number'], 'g'),
                    matrix: /matrix$/i,
                    matrix3D: /matrix3d$/i,
                    skewXY: /skew(x|y)?$/i,
                    rotate3D: /rotate3d$/i,
                };
            }
            var state = index_1.default.guardFunctions(value);
            return {
                prop: prop,
                value: index_1.default.unguardFunctions(state, function (v, n) {
                    if (n.length) {
                        if (n.match(this.cache.matrix3D)) {
                            v = this.flipMatrix3D(v);
                        }
                        else if (n.match(this.cache.matrix)) {
                            v = this.flipMatrix(v);
                        }
                        else if (n.match(this.cache.rotate3D)) {
                            v = this.flipRotate3D(v);
                        }
                        else if (n.match(this.cache.skewXY)) {
                            v = index_1.default.negateAll(v);
                        }
                        else if (n.match(this.cache.negatable)) {
                            v = index_1.default.negate(v);
                        }
                    }
                    return v;
                }.bind(this)),
            };
        },
    },
    {
        name: 'transition',
        expr: /transition(-property)?$/i,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLeftRight(value) };
        },
    },
    {
        name: 'background',
        expr: /background(-position(-x)?|-image)?$/i,
        cache: null,
        flip: function (value) {
            var state = index_1.default.saveTokens(value, true);
            var parts = state.value.match(this.cache.match);
            if (parts && parts.length > 0) {
                var keywords = (state.value.match(this.cache.position) || '').length;
                if (parts.length >= 3 ||
                    keywords === 2) {
                    state.value = index_1.default.swapLeftRight(state.value);
                }
                else {
                    parts[0] =
                        parts[0] === '0'
                            ? '100%'
                            : parts[0].match(this.cache.percent)
                                ? index_1.default.complement(parts[0])
                                : parts[0].match(this.cache.length)
                                    ? index_1.default.flipLength(parts[0])
                                    : index_1.default.swapLeftRight(parts[0]);
                    state.value = state.value.replace(this.cache.match, function () {
                        return parts.shift();
                    });
                }
            }
            return index_1.default.restoreTokens(state);
        },
        update: function (context, value, name) {
            if (name.match(this.cache.gradient)) {
                value = index_1.default.swapLeftRight(value);
                if (value.match(this.cache.angle)) {
                    value = index_1.default.negate(value);
                }
            }
            else if (context.config.processUrls === true ||
                (context.config.processUrls.decl === true && name.match(this.cache.url))) {
                value = index_1.default.applyStringMap(value, true);
            }
            return value;
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    match: index_1.default.regex(['position', 'percent', 'length', 'calc'], 'ig'),
                    percent: index_1.default.regex(['calc', 'percent'], 'i'),
                    position: index_1.default.regex(['position'], 'g'),
                    length: index_1.default.regex(['length'], 'gi'),
                    gradient: /gradient$/i,
                    angle: /\d+(deg|g?rad|turn)/i,
                    url: /^url/i,
                };
            }
            var colorSafe = index_1.default.guardHexColors(value);
            var funcSafe = index_1.default.guardFunctions(colorSafe.value);
            var parts = funcSafe.value.split(',');
            var lprop = prop.toLowerCase();
            if (lprop !== 'background-image') {
                for (var x = 0; x < parts.length; x++) {
                    parts[x] = this.flip(parts[x]);
                }
            }
            funcSafe.value = parts.join(',');
            colorSafe.value = index_1.default.unguardFunctions(funcSafe, this.update.bind(this, { config: index_1.config }));
            return {
                prop: prop,
                value: index_1.default.unguardHexColors(colorSafe),
            };
        },
    },
    {
        name: 'keyword',
        expr: /float|clear|text-align|textAlign/i,
        action: function (prop, value) {
            return { prop: prop, value: index_1.default.swapLeftRight(value) };
        },
    },
    {
        name: 'cursor',
        expr: /cursor/i,
        cache: null,
        update: function (context, value, name) {
            if (context.config.processUrls === true ||
                (context.config.processUrls.decl === true && name.match(this.cache.url))) {
                value = index_1.default.applyStringMap(value, true);
            }
            return value;
        },
        flip: function (value) {
            return value.replace(this.cache.replace, function (s, m) {
                return s.replace(m, m
                    .replace(this.cache.e, '*')
                    .replace(this.cache.w, 'e')
                    .replace(this.cache.star, 'w'));
            }.bind(this));
        },
        action: function (prop, value) {
            if (this.cache === null) {
                this.cache = {
                    replace: /\b(ne|nw|se|sw|nesw|nwse)-resize/gi,
                    url: /^url/i,
                    e: /e/i,
                    w: /w/i,
                    star: /\*/i,
                };
            }
            var state = index_1.default.guardFunctions(value);
            var parts = state.value.split(',');
            for (var x = 0; x < parts.length; x++) {
                parts[x] = this.flip(parts[x]);
            }
            state.value = parts.join(',');
            return {
                prop: prop,
                value: index_1.default.unguardFunctions(state, this.update.bind(this, { config: index_1.config })),
            };
        },
    },
];
exports.process = function (cssProp, cssValue) {
    var result;
    var defaultResult = { prop: cssProp, value: cssValue };
    if (cssValue === undefined || cssValue === null)
        return defaultResult;
    for (var _i = 0, processorList_1 = exports.processorList; _i < processorList_1.length; _i++) {
        var processor = processorList_1[_i];
        if (cssProp.match(processor.expr)) {
            result = processor.action(cssProp, cssValue);
            break;
        }
    }
    return result || defaultResult;
};
exports.scaleCss = 'scaleX( -1)';


/***/ }),

/***/ "./src/utilities/containers.ts":
/*!*************************************!*\
  !*** ./src/utilities/containers.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.walkContainer = void 0;
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var directives_1 = __webpack_require__(/*! @utilities/directives */ "./src/utilities/directives.ts");
exports.walkContainer = function (container, filter, directiveCallback, nodeCallback) {
    container.each(function (node) {
        if (node.type !== _constants_1.COMMENT_TYPE && !filter.includes(node.type))
            return;
        if (node.type === _constants_1.COMMENT_TYPE) {
            var comment = node;
            var controlDirective = directives_1.getControlDirective(comment);
            if (controlDirective) {
                directiveCallback(comment, controlDirective);
            }
        }
        else {
            nodeCallback(node);
        }
    });
};


/***/ }),

/***/ "./src/utilities/declarations.ts":
/*!***************************************!*\
  !*** ./src/utilities/declarations.ts ***!
  \***************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasIgnoreDirectiveInRaws = exports.appendDeclarationToRule = exports.initialValues = exports.allDeclarations = exports.declarations = void 0;
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var shorthand_declarations_json_1 = __importDefault(__webpack_require__(/*! @data/shorthand-declarations.json */ "./src/data/shorthand-declarations.json"));
var not_shorthand_declarations_json_1 = __importDefault(__webpack_require__(/*! @data/not-shorthand-declarations.json */ "./src/data/not-shorthand-declarations.json"));
var initial_values_json_1 = __importDefault(__webpack_require__(/*! @data/initial-values.json */ "./src/data/initial-values.json"));
var declarationsData = shorthand_declarations_json_1.default;
var notShorthandDeclarationsArray = not_shorthand_declarations_json_1.default;
var initialValuesData = initial_values_json_1.default;
var declarations = {};
exports.declarations = declarations;
var allDeclarations = {};
exports.allDeclarations = allDeclarations;
var initialValues = {};
exports.initialValues = initialValues;
var getOverrideTree = function (prop) {
    var overridenProp = declarationsData[prop].overridden;
    var overridden = overridenProp ? [overridenProp].concat(getOverrideTree(overridenProp)) : [];
    return overridden;
};
Object.keys(declarationsData).forEach(function (prop) {
    var overrideTree = getOverrideTree(prop);
    declarations[prop] = overrideTree;
    declarationsData[prop].overrides.forEach(function (oprop) {
        declarations[oprop] = [prop].concat(overrideTree);
    });
});
Object.assign(allDeclarations, declarations);
notShorthandDeclarationsArray.forEach(function (declaration) {
    allDeclarations[declaration] = [];
});
Object.keys(initialValuesData).forEach(function (value) {
    initialValuesData[value].forEach(function (prop) {
        initialValues[prop] = value;
    });
});
var appendDeclarationToRule = function (decl, rule) {
    var declClone = decl.clone();
    var declPrev = decl.prev();
    if (declPrev && declPrev.type === _constants_1.COMMENT_TYPE) {
        var commentClone = declPrev.clone();
        rule.append(commentClone);
        declPrev.remove();
    }
    rule.append(declClone);
};
exports.appendDeclarationToRule = appendDeclarationToRule;
var hasIgnoreDirectiveInRaws = function (decl) {
    var raws = !!decl.raws && !!decl.raws.value && decl.raws.value.raw;
    if (raws && _constants_1.RTL_COMMENT_IGNORE_REGEXP.test(raws)) {
        return true;
    }
    return false;
};
exports.hasIgnoreDirectiveInRaws = hasIgnoreDirectiveInRaws;


/***/ }),

/***/ "./src/utilities/directives.ts":
/*!*************************************!*\
  !*** ./src/utilities/directives.ts ***!
  \*************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.getSourceDirectiveValue = exports.checkDirective = exports.isIgnoreDirectiveInsideAnIgnoreBlock = exports.getControlDirective = exports.isValidMatchDirective = void 0;
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var CONTROL_DIRECTIVE_VALUES = Object.values(_constants_1.CONTROL_DIRECTIVE);
var CONTROL_DIRECTIVE_BLOCK_VALUES = Object.values(_constants_1.CONTROL_DIRECTIVE_BLOCK);
exports.isValidMatchDirective = function (match) {
    return CONTROL_DIRECTIVE_VALUES.includes("" + match[2]) &&
        (match[1] === undefined ||
            CONTROL_DIRECTIVE_BLOCK_VALUES.includes("" + match[1]));
};
exports.getControlDirective = function (comment) {
    var commentStr = comment.toString();
    var match = commentStr.match(_constants_1.RTL_CONTROL_DIRECTIVE_REG_EXP);
    if (match && exports.isValidMatchDirective(match)) {
        var controlDirective = {
            directive: match[2]
        };
        if (match[1]) {
            controlDirective.block = match[1];
        }
        if (match[3]) {
            controlDirective.option = match[3];
        }
        return controlDirective;
    }
    return null;
};
exports.isIgnoreDirectiveInsideAnIgnoreBlock = function (controlDirective, controlDirectives) { return (controlDirective.directive === _constants_1.CONTROL_DIRECTIVE.IGNORE &&
    !controlDirective.block &&
    controlDirectives[_constants_1.CONTROL_DIRECTIVE.IGNORE] &&
    controlDirectives[_constants_1.CONTROL_DIRECTIVE.IGNORE].block === _constants_1.CONTROL_DIRECTIVE_BLOCK.BEGIN); };
exports.checkDirective = function (controlDirectives, directiveType) {
    var directive = controlDirectives[directiveType];
    if (directive) {
        var block = directive.block;
        if (block !== _constants_1.CONTROL_DIRECTIVE_BLOCK.BEGIN) {
            delete controlDirectives[directiveType];
        }
        if (block !== _constants_1.CONTROL_DIRECTIVE_BLOCK.END) {
            return true;
        }
    }
    return false;
};
exports.getSourceDirectiveValue = function (controlDirectives, parentValue) {
    var sourceControlDirective = controlDirectives[_constants_1.CONTROL_DIRECTIVE.SOURCE];
    var sourceDirective = exports.checkDirective(controlDirectives, _constants_1.CONTROL_DIRECTIVE.SOURCE);
    return sourceControlDirective && sourceDirective
        ? sourceControlDirective.option
        : parentValue || undefined;
};


/***/ }),

/***/ "./src/utilities/index.ts":
/*!********************************!*\
  !*** ./src/utilities/index.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDisabledClassName = exports.addDisabledClassName = exports.disabledClassNames = exports.isBlank = exports.isIgnoreComponent = exports.initRuntimeOption = exports.addDisabledComponents = exports.stashReact = exports.disabledComponents = exports.normalizeStyleBinding = exports.toObject = exports.extend = exports.setSkipStatus = exports.skipCSSProcess = exports.setRTLStatus = exports.isRTL = exports.config = void 0;
exports.config = {
    autoRename: false,
    autoRenameStrict: false,
    clean: true,
    greedy: false,
    processUrls: false,
    stringMap: [],
    useCalc: false,
};
var CHAR_COMMENT_REPLACEMENT = '\uFFFD';
var CHAR_TOKEN_REPLACEMENT = '\u00A4';
var CHAR_TOKEN_START = '\u00AB';
var CHAR_TOKEN_END = '\u00BB';
var REGEX_COMMENT_REPLACEMENT = new RegExp(CHAR_COMMENT_REPLACEMENT, 'ig');
var REGEX_TOKEN_REPLACEMENT = new RegExp(CHAR_TOKEN_REPLACEMENT, 'ig');
var PATTERN_NUMBER = '\\-?(\\d*?\\.\\d+|\\d+)';
var PATTERN_NUMBER_WITH_CALC = '(calc' + CHAR_TOKEN_REPLACEMENT + ')|(' + PATTERN_NUMBER + ')(?!d\\()';
var PATTERN_TOKEN = CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END;
var PATTERN_TOKEN_WITH_NAME = '\\w*?' + CHAR_TOKEN_START + '\\d+:\\d+' + CHAR_TOKEN_END;
var REGEX_COMMENT = /\/\*[^]*?\*\//gim;
var REGEX_DIRECTIVE = /\/\*\s*(?:!)?\s*rtl:[^]*?\*\//gim;
var REGEX_ESCAPE = /[.*+?^${}()|[\]\\]/g;
var REGEX_FUNCTION = /\([^\(\)]+\)/i;
var REGEX_HEX_COLOR = /#[a-f0-9]{3,6}/gi;
var REGEX_CALC = /calc/;
var REGEX_TOKENS = new RegExp(PATTERN_TOKEN, 'ig');
var REGEX_TOKENS_WITH_NAME = new RegExp(PATTERN_TOKEN_WITH_NAME, 'ig');
var REGEX_COMPLEMENT = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i');
var REGEX_NEGATE_ALL = new RegExp(PATTERN_NUMBER_WITH_CALC, 'ig');
var REGEX_NEGATE_ONE = new RegExp(PATTERN_NUMBER_WITH_CALC, 'i');
var DEFAULT_STRING_MAP_OPTIONS = { scope: '*', ignoreCase: true };
var TOKEN_ID = 0;
function compare(what, to, ignoreCase) {
    if (ignoreCase) {
        return what.toLowerCase() === to.toLowerCase();
    }
    return what === to;
}
function escapeRegExp(string) {
    return string.replace(REGEX_ESCAPE, '\\$&');
}
var utilsStore = {
    extend: function (dest, src) {
        if (typeof dest === 'undefined' || typeof dest !== 'object') {
            dest = {};
        }
        for (var prop in src) {
            if (!dest.hasOwnProperty(prop)) {
                dest[prop] = src[prop];
            }
        }
        return dest;
    },
    swap: function (value, a, b, options) {
        var expr = escapeRegExp(a) + '|' + escapeRegExp(b);
        options = options || DEFAULT_STRING_MAP_OPTIONS;
        var greedy = options.hasOwnProperty('greedy')
            ? options.greedy
            : exports.config.greedy;
        if (!greedy) {
            expr = '\\b(' + expr + ')\\b';
        }
        var flags = options.ignoreCase ? 'img' : 'mg';
        return value.replace(new RegExp(expr, flags), function (m) {
            return compare(m, a, options.ignoreCase) ? b : a;
        });
    },
    swapLeftRight: function (value) {
        return this.swap(value, 'left', 'right');
    },
    swapLtrRtl: function (value) {
        return this.swap(value, 'ltr', 'rtl');
    },
    applyStringMap: function (value, isUrl) {
        var result = value;
        for (var x = 0; x < exports.config.stringMap.length; x++) {
            var map = exports.config.stringMap[x];
            var options = this.extend(map.options, DEFAULT_STRING_MAP_OPTIONS);
            if (options.scope === '*' ||
                (isUrl && options.scope === 'url') ||
                (!isUrl && options.scope === 'selector')) {
                if (Array.isArray(map.search) && Array.isArray(map.replace)) {
                    for (var mapIndex = 0; mapIndex < map.search.length; mapIndex++) {
                        result = this.swap(result, map.search[mapIndex], map.replace[mapIndex % map.search.length], options);
                    }
                }
                else {
                    result = this.swap(result, map.search, map.replace, options);
                }
                if (map.exclusive === true) {
                    break;
                }
            }
        }
        return result;
    },
    negate: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_NEGATE_ONE, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(-1*' + m + ')';
                })
                : parseFloat(num) * -1;
        });
        return this.restoreTokens(state);
    },
    negateAll: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_NEGATE_ALL, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(-1*' + m + ')';
                })
                : parseFloat(num) * -1;
        });
        return this.restoreTokens(state);
    },
    complement: function (value) {
        var state = this.saveTokens(value);
        state.value = state.value.replace(REGEX_COMPLEMENT, function (num) {
            return REGEX_TOKEN_REPLACEMENT.test(num)
                ? num.replace(REGEX_TOKEN_REPLACEMENT, function (m) {
                    return '(100% - ' + m + ')';
                })
                : 100 - parseFloat(num);
        });
        return this.restoreTokens(state);
    },
    flipLength: function (value) {
        return exports.config.useCalc ? 'calc(100% - ' + value + ')' : value;
    },
    save: function (what, who, replacement, restorer, exclude) {
        var state = {
            value: who,
            store: [],
            replacement: replacement,
            restorer: restorer,
        };
        state.value = state.value.replace(what, function (c) {
            if (exclude && c.match(exclude)) {
                return c;
            }
            else {
                state.store.push(c);
                return state.replacement;
            }
        });
        return state;
    },
    restore: function (state) {
        var index = 0;
        var result = state.value.replace(state.restorer, function () {
            return state.store[index++];
        });
        state.store.length = 0;
        return result;
    },
    saveComments: function (value) {
        return this.save(REGEX_COMMENT, value, CHAR_COMMENT_REPLACEMENT, REGEX_COMMENT_REPLACEMENT);
    },
    restoreComments: function (state) {
        return this.restore(state);
    },
    saveTokens: function (value, excludeCalc) {
        return excludeCalc === true
            ? this.save(REGEX_TOKENS_WITH_NAME, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT, REGEX_CALC)
            : this.save(REGEX_TOKENS, value, CHAR_TOKEN_REPLACEMENT, REGEX_TOKEN_REPLACEMENT);
    },
    restoreTokens: function (state) {
        return this.restore(state);
    },
    guard: function (what, who, indexed) {
        var state = {
            value: who,
            store: [],
            offset: TOKEN_ID++,
            token: CHAR_TOKEN_START + TOKEN_ID,
            indexed: indexed === true,
        };
        if (state.indexed === true) {
            while (what.test(state.value)) {
                state.value = state.value.replace(what, function (m) {
                    state.store.push(m);
                    return state.token + ':' + state.store.length + CHAR_TOKEN_END;
                });
            }
        }
        else {
            state.value = state.value.replace(what, function (m) {
                state.store.push(m);
                return state.token + CHAR_TOKEN_END;
            });
        }
        return state;
    },
    unguard: function (state, callback) {
        if (state.indexed === true) {
            var detokenizer = new RegExp('(\\w*?)' + state.token + ':(\\d+)' + CHAR_TOKEN_END, 'i');
            while (detokenizer.test(state.value)) {
                state.value = state.value.replace(detokenizer, function (match, name, index) {
                    var value = state.store[index - 1];
                    if (typeof callback === 'function') {
                        return name + callback(value, name);
                    }
                    return name + value;
                });
            }
            return state.value;
        }
        else {
            return state.value.replace(new RegExp('(\\w*?)' + state.token + CHAR_TOKEN_END, 'i'), function (match, name) {
                var value = state.store.shift();
                if (typeof callback === 'function') {
                    return name + callback(value, name);
                }
                return name + value;
            });
        }
    },
    guardHexColors: function (value) {
        return this.guard(REGEX_HEX_COLOR, value, true);
    },
    unguardHexColors: function (state, callback) {
        return this.unguard(state, callback);
    },
    guardFunctions: function (value) {
        return this.guard(REGEX_FUNCTION, value, true);
    },
    unguardFunctions: function (state, callback) {
        return this.unguard(state, callback);
    },
    trimDirective: function (value) {
        return value.replace(REGEX_DIRECTIVE, '');
    },
    regexCache: {},
    regexDirective: function (name) {
        this.regexCache[name] =
            this.regexCache[name] ||
                new RegExp('(?:\\/\\*\\s*(?:!)?\\s*rtl:' +
                    (name ? escapeRegExp(name) + '(?::)?' : '') +
                    ')([^]*?)(?:\\*\\/)', 'img');
        return this.regexCache[name];
    },
    regex: function (what, options) {
        what = what || [];
        var expression = '';
        for (var x = 0; x < what.length; x++) {
            switch (what[x]) {
                case 'percent':
                    expression += '|(' + PATTERN_NUMBER + '%)';
                    break;
                case 'length':
                    expression +=
                        '|(' +
                            PATTERN_NUMBER +
                            ')(?:ex|ch|r?em|vh|vw|vmin|vmax|px|mm|cm|in|pt|pc)?';
                    break;
                case 'number':
                    expression += '|(' + PATTERN_NUMBER + ')';
                    break;
                case 'position':
                    expression += '|(left|center|right|top|bottom)';
                    break;
                case 'calc':
                    expression += '|(calc' + PATTERN_TOKEN + ')';
                    break;
            }
        }
        return new RegExp(expression.slice(1), options);
    },
    isLastOfType: function (node) {
        var isLast = true;
        var next = node.next();
        while (next) {
            if (next && next.type === node.type) {
                isLast = false;
                break;
            }
            next = next.next();
        }
        return isLast;
    },
    each: function (array, callback) {
        for (var len = 0; len < array.length; len++) {
            if (callback(array[len]) === false) {
                return false;
            }
        }
        return true;
    },
};
exports.setRTLStatus = function (is) {
    exports.isRTL = is;
};
exports.setSkipStatus = function (is) {
    exports.skipCSSProcess = is;
};
exports.extend = function extend(to, _from) {
    for (var key in _from) {
        to[key] = _from[key];
    }
    return to;
};
exports.toObject = function toObject(arr) {
    var res = {};
    for (var i = 0; i < arr.length; i++) {
        if (arr[i]) {
            exports.extend(res, arr[i]);
        }
    }
    return res;
};
exports.normalizeStyleBinding = function (bindingStyle) {
    if (Array.isArray(bindingStyle)) {
        return exports.toObject(bindingStyle);
    }
    if (typeof bindingStyle === 'string') {
        return parseStyleText(bindingStyle);
    }
    return bindingStyle;
};
exports.disabledComponents = [];
exports.addDisabledComponents = function (components) {
    exports.disabledComponents = __spreadArrays(exports.disabledComponents, components);
};
var resetDisabledComponents = function () {
    exports.disabledComponents = [];
};
exports.initRuntimeOption = function (option, react) {
    if (!option)
        return;
    exports.stashReact = react;
    if (option.disabledComponent) {
        resetDisabledComponents();
        exports.addDisabledComponents(option.disabledComponent);
    }
};
exports.isIgnoreComponent = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    if (!exports.disabledComponents.length)
        return;
    var current = (_b = (_a = exports.stashReact === null || exports.stashReact === void 0 ? void 0 : exports.stashReact.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || _a === void 0 ? void 0 : _a.ReactCurrentOwner) === null || _b === void 0 ? void 0 : _b.current;
    if (!current)
        return;
    var name = (_c = current === null || current === void 0 ? void 0 : current.elementType) === null || _c === void 0 ? void 0 : _c.name;
    if (!name)
        return;
    if (exports.disabledComponents.includes(name))
        return true;
    var parentName = ((_e = (_d = current === null || current === void 0 ? void 0 : current._debugOwner) === null || _d === void 0 ? void 0 : _d.elementType) === null || _e === void 0 ? void 0 : _e.name) || ((_h = (_g = (_f = current === null || current === void 0 ? void 0 : current._debugOwner) === null || _f === void 0 ? void 0 : _f.elementType) === null || _g === void 0 ? void 0 : _g.render) === null || _h === void 0 ? void 0 : _h.displayName);
    if (!parentName)
        return;
    if (exports.disabledComponents.includes(parentName) && !exports.disabledComponents.includes(name)) {
        exports.addDisabledComponents([name]);
        return true;
    }
};
exports.isBlank = function (value) {
    return value === undefined || value === null;
};
exports.disabledClassNames = [];
exports.addDisabledClassName = function (className) {
    exports.disabledClassNames.push.apply(exports.disabledClassNames, className.split(' '));
};
exports.isDisabledClassName = function (className) {
    return exports.disabledClassNames.length && className.split(' ').some(function (item) { return exports.disabledClassNames.includes(item); });
};
var parseStyleText = function (cssText) {
    var res = {};
    var listDelimiter = /;(?![^(]*\))/g;
    var propertyDelimiter = /:(.+)/;
    cssText.split(listDelimiter).forEach(function (item) {
        if (item) {
            var tmp = item.split(propertyDelimiter);
            tmp.length > 1 && (res[tmp[0].trim()] = tmp[1].trim());
        }
    });
    return res;
};
exports.default = utilsStore;


/***/ }),

/***/ "./src/utilities/rules.ts":
/*!********************************!*\
  !*** ./src/utilities/rules.ts ***!
  \********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.appendAutorenameRules = exports.appendKeyFrames = exports.appendRules = exports.removeEmptyRules = exports.cleanRules = exports.cleanRuleRawsBefore = exports.appendParentRuleToStore = exports.insertRuleIntoStore = exports.appendRulesToRuleObject = exports.insertRules = exports.getParentRules = exports.ruleHasChildren = exports.ruleHasDeclarations = void 0;
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var _constants_1 = __webpack_require__(/*! @constants */ "./src/constants/index.ts");
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
var selectors_1 = __webpack_require__(/*! @utilities/selectors */ "./src/utilities/selectors.ts");
exports.ruleHasDeclarations = function (rule) {
    return rule.some(function (node) { return node.type === _constants_1.DECLARATION_TYPE; });
};
exports.ruleHasChildren = function (rule) {
    return rule.some(function (node) { return (node.type === _constants_1.DECLARATION_TYPE ||
        (node.type === _constants_1.RULE_TYPE &&
            exports.ruleHasChildren(node))); });
};
exports.getParentRules = function (rule) {
    var rules = [];
    while (rule.type === _constants_1.RULE_TYPE) {
        rules.push(rule);
        rule = rule.parent;
    }
    rules.shift();
    return rules.reverse();
};
exports.insertRules = function (parent, rule, rules) {
    if (exports.ruleHasDeclarations(rule)) {
        rules = __spreadArrays(rules);
        var parentRule_1;
        while (rules.length) {
            parentRule_1 = rules.shift();
            var innerRule = parent.nodes.find(function (node) {
                if (node.type === _constants_1.RULE_TYPE &&
                    node.selector === parentRule_1.selector) {
                    return true;
                }
            });
            if (innerRule) {
                parentRule_1 = innerRule;
            }
            else {
                parentRule_1 = parentRule_1.clone().removeAll();
                parent.append(parentRule_1);
            }
            parent = parentRule_1;
        }
        parent.append(rule);
    }
};
exports.appendRulesToRuleObject = function (ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe, ruleObject, rules) {
    exports.insertRules(ruleObject.ruleLTR, ruleFlipped, rules);
    exports.insertRules(ruleObject.ruleRTL, ruleFlippedSecond, rules);
    exports.insertRules(ruleObject.ruleBoth, ruleBoth, rules);
    exports.insertRules(ruleObject.ruleSafe, ruleSafe, rules);
};
exports.insertRuleIntoStore = function (rule, ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe) {
    var rulesObject = {
        rule: rule,
        ruleLTR: ruleFlipped,
        ruleRTL: ruleFlippedSecond,
        ruleBoth: ruleBoth,
        ruleSafe: ruleSafe
    };
    selectors_1.addProperSelectorPrefixes(ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe);
    store_1.store.rules.push(rulesObject);
    return rulesObject;
};
exports.appendParentRuleToStore = function (rule, ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe) {
    var rules = exports.getParentRules(rule);
    var root = rules.shift();
    var rootRulesObject = store_1.store.rules.find(function (rObject) { return rObject.rule === root; });
    if (!rootRulesObject) {
        var rootRuleFlipped = root.clone().removeAll();
        var rootRuleFlippedSecond = rootRuleFlipped.clone();
        var rootRuleBoth = rootRuleFlipped.clone();
        var rootRruleSafe = rootRuleFlipped.clone();
        rootRulesObject = exports.insertRuleIntoStore(root, rootRuleFlipped, rootRuleFlippedSecond, rootRuleBoth, rootRruleSafe);
    }
    exports.appendRulesToRuleObject(ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe, rootRulesObject, rules);
};
exports.cleanRuleRawsBefore = function (node) {
    if (node && node.type === _constants_1.RULE_TYPE) {
        node.raws.before = '\n\n' + node.raws.before.replace(/\n/g, '');
    }
};
exports.cleanRules = function () {
    var rules = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        rules[_i] = arguments[_i];
    }
    rules.forEach(function (rule) {
        var prev = rule.prev();
        if (prev && prev.type !== _constants_1.COMMENT_TYPE) {
            exports.cleanRuleRawsBefore(rule);
        }
        rule.walk(function (node) {
            if (node.type === _constants_1.DECLARATION_TYPE) {
                var decl = node;
                if (decl.raws && decl.raws.value && _constants_1.RTL_COMMENT_REGEXP.test(decl.raws.value.raw)) {
                    delete decl.raws.value;
                    decl.value = decl.value.trim();
                }
            }
        });
    });
};
exports.removeEmptyRules = function (rule) {
    if (exports.ruleHasChildren(rule)) {
        rule.walkRules(function (r) {
            exports.removeEmptyRules(r);
            if (!exports.ruleHasChildren(r)) {
                r.remove();
            }
        });
    }
    else {
        rule.remove();
    }
};
exports.appendRules = function () {
    var rules = store_1.store.rules;
    rules.forEach(function (_a) {
        var rule = _a.rule, ruleLTR = _a.ruleLTR, ruleRTL = _a.ruleRTL, ruleBoth = _a.ruleBoth, ruleSafe = _a.ruleSafe;
        ruleBoth && ruleBoth.nodes.length && rule.after(ruleBoth);
        ruleRTL && ruleRTL.nodes.length && rule.after(ruleRTL);
        ruleLTR && ruleLTR.nodes.length && rule.after(ruleLTR);
        ruleSafe && ruleSafe.nodes.length && rule.after(ruleSafe);
        exports.removeEmptyRules(rule);
        exports.cleanRules(rule, ruleLTR, ruleRTL, ruleBoth, ruleSafe);
    });
};
exports.appendKeyFrames = function () {
    var keyframes = store_1.store.keyframes;
    keyframes.forEach(function (_a) {
        var atRule = _a.atRule, atRuleFlipped = _a.atRuleFlipped;
        atRule.after(atRuleFlipped);
        exports.cleanRules(atRule, atRuleFlipped);
    });
};
exports.appendAutorenameRules = function () {
    if (!store_1.store.rulesAutoRename.length) {
        return;
    }
    var replaceHash = store_1.store.options.stringMap.reduce(function (hash, map) {
        var search = typeof map.search === 'string' ? [map.search] : map.search;
        var replace = typeof map.replace === 'string' ? [map.replace] : map.replace;
        search.forEach(function (s, index) {
            hash[s] = replace[index];
            hash[replace[index]] = s;
        });
        return hash;
    }, {});
    var replaces = Object.keys(replaceHash).join('|');
    var replaceRegExp = store_1.store.options.greedy
        ? new RegExp("(" + replaces + ")", 'g')
        : new RegExp("\\b(" + replaces + ")\\b", 'g');
    var rulesHash = {};
    var rulesToProcess = [];
    store_1.store.rulesAutoRename.forEach(function (rule) {
        var process = false;
        rule.selectors.forEach(function (selector) {
            if (replaceRegExp.test(selector)) {
                rulesHash[selector] = true;
                process = true;
            }
            replaceRegExp.lastIndex = 0;
        });
        if (process) {
            rulesToProcess.push(rule);
        }
    });
    rulesToProcess.forEach(function (rule) {
        rule.selectors = rule.selectors.map(function (selector) {
            var flip = selector.replace(replaceRegExp, function (match, group) { return replaceHash[group]; });
            if (store_1.store.options.autoRename !== _types_1.Autorename.strict ||
                (store_1.store.options.autoRename === _types_1.Autorename.strict && rulesHash[flip])) {
                return flip;
            }
            return selector;
        });
    });
};


/***/ }),

/***/ "./src/utilities/selectors.ts":
/*!************************************!*\
  !*** ./src/utilities/selectors.ts ***!
  \************************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.addProperSelectorPrefixes = exports.addSelectorPrefixes = void 0;
var _types_1 = __webpack_require__(/*! @types */ "./src/@types/index.ts");
var store_1 = __webpack_require__(/*! @data/store */ "./src/data/store.ts");
exports.addSelectorPrefixes = function (rule, prefixes) {
    rule.selectors = typeof prefixes === 'string'
        ? rule.selectors.map(function (selector) { return prefixes + " " + selector; })
        : rule.selectors.reduce(function (selectors, selector) {
            selectors = selectors.concat(prefixes.map(function (prefix) { return prefix + " " + selector; }));
            return selectors;
        }, []);
};
exports.addProperSelectorPrefixes = function (ruleFlipped, ruleFlippedSecond, ruleBoth, ruleSafe) {
    var _a = store_1.store.options, mode = _a.mode, ltrPrefix = _a.ltrPrefix, rtlPrefix = _a.rtlPrefix, bothPrefix = _a.bothPrefix, source = _a.source;
    if (mode === _types_1.Mode.combined) {
        exports.addSelectorPrefixes(ruleFlipped, source === _types_1.Source.ltr ? ltrPrefix : rtlPrefix);
        exports.addSelectorPrefixes(ruleFlippedSecond, source === _types_1.Source.rtl ? ltrPrefix : rtlPrefix);
    }
    else {
        exports.addSelectorPrefixes(ruleFlipped, source === _types_1.Source.ltr ? rtlPrefix : ltrPrefix);
        exports.addSelectorPrefixes(ruleFlippedSecond, source === _types_1.Source.rtl ? rtlPrefix : ltrPrefix);
    }
    exports.addSelectorPrefixes(ruleBoth, bothPrefix);
    exports.addSelectorPrefixes(ruleSafe, bothPrefix);
};


/***/ }),

/***/ "./src/utilities/vendor.ts":
/*!*********************************!*\
  !*** ./src/utilities/vendor.ts ***!
  \*********************************/
/*! no static exports found */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.vendor = void 0;
var REG = /^-\w+-/;
exports.vendor = {
    unprefixed: function (prop) { return prop.replace(REG, ''); }
};


/***/ }),

/***/ "postcss":
/*!**************************!*\
  !*** external "postcss" ***!
  \**************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("postcss");

/***/ }),

/***/ "react":
/*!************************!*\
  !*** external "react" ***!
  \************************/
/*! no static exports found */
/***/ (function(module, exports) {

module.exports = require("react");

/***/ })

/******/ })));